import { Translations } from './types';

export const translationsEs: Translations = {
  landing: {
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    hero: {
      eyebrow: 'Bienvenido',
      title: 'Vamos a configurar tu cuenta',
      subhead:
        'Crear tu cuenta de Data Mission lleva unos dos minutos. Esto es lo que puedes esperar antes de iniciar el registro, para que nada te sorprenda.',
      illustrationAlt: 'Ilustración de una mano conectando un enchufe a una nube',
    },
    steps: {
      stepLabel: 'Paso',
      step1Title: 'Introduce tu correo electrónico',
      step1Body:
        'Lo usaremos como tu nombre de usuario y te enviaremos allí el siguiente paso. Usa un correo del trabajo si es posible, ya que esta será la cuenta vinculada a tu equipo.',
      step2Title: 'Verifica con un código de un solo uso',
      step2Body:
        'Busca en tu bandeja de entrada un código de seis dígitos enviado por nosotros y pégalo en la pantalla de registro. Tarda unos segundos y confirma que el correo es tuyo.',
      step3Title: 'Establece tu contraseña',
      step3Body:
        'Elige una contraseña y completa algunos datos básicos sobre ti. Esta es la cuenta que usarás para volver a iniciar sesión cada vez que regreses.',
      step4Title: 'Completa la introducción guiada',
      step4Body:
        'Una vez dentro, te guiaremos paso a paso para conectar tu primera fuente y configurar tu primera sincronización. Sin necesidad de buscar en la documentación.',
    },
    cta: {
      headline: 'Listos cuando lo estés',
      subhead:
        'La pantalla de registro está alojada por Microsoft Entra. Parece un inicio de sesión, pero estás en el lugar correcto.',
      signUpEmail: 'Registrarse con correo',
      signUpMicrosoft: 'Registrarse con Microsoft',
      microsoftIconAlt: 'Logotipo de Microsoft',
    },
    signInCard: {
      text: '¿Ya tienes una cuenta?',
      link: 'Inicia sesión ›',
    },
    footer: {
      privacyPolicy: 'Política de privacidad',
      termsOfUse: 'Condiciones de uso',
    },
  },
  support: {
    title: 'Soporte',
    description: 'Obtenga ayuda con Data Mission Sync, contacte a su socio y haga seguimiento de sus tickets de soporte.',
    unavailable: 'El soporte no está disponible temporalmente. Vuelva a intentarlo en unos minutos.',
    helpCenter: {
      title: 'Centro de ayuda',
      description: 'Consulte guías y respuestas a preguntas frecuentes.',
      open: 'Abrir el centro de ayuda',
    },
    partner: {
      title: 'Su socio',
      description: 'Su organización cuenta con el apoyo de este socio.',
      logoAlt: 'Logotipo de {name}',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      website: 'Sitio web',
      location: 'Ubicación',
    },
    visibility: {
      title: 'Visibilidad',
      withPartner: 'Todos los usuarios de esta organización pueden ver y comentar los tickets de soporte, incluido su socio, {name}.',
      withoutPartner: 'Todos los usuarios de esta organización pueden ver y comentar los tickets de soporte. Si tiene un socio asignado, también puede hacerlo.',
    },
    status: {
      WaitingOnYou: 'Esperando su respuesta',
      WaitingOnYouTooltip: 'Soporte respondió y necesita algo de usted. Su respuesta le devuelve el ticket.',
      Open: 'Abierto',
      OpenTooltip: 'Esperando a que el equipo de soporte lo atienda.',
      InProgress: 'En curso',
      InProgressTooltip: 'El equipo de soporte está trabajando en ello.',
      Resolved: 'Resuelto',
      ResolvedTooltip: 'El equipo de soporte lo ha resuelto. Agregue un comentario si aún necesita ayuda.',
      Closed: 'Cerrado',
      ClosedTooltip: 'El ticket está cerrado. Aún puede agregar un comentario.',
    },
    person: {
      you: 'Usted',
      teamMember: 'Miembro del equipo',
      supportTeam: 'Equipo de soporte',
      aiSummary: 'Resumen de IA',
      supportRole: 'Soporte',
    },
    waitingBanner: {
      titleOne: 'Soporte espera su respuesta en 1 ticket',
      titleOther: 'Soporte espera su respuesta en {count} tickets',
      body: 'Responda para que todo siga avanzando.',
      action: 'Ver tickets',
    },
    tickets: {
      title: 'Tickets de soporte',
      description: 'Todos los tickets de su organización, creados por cualquier miembro de su equipo.',
      newTicket: 'Nuevo ticket',
      loading: 'Cargando tickets...',
      loadFailed: 'No se pudieron cargar los tickets de soporte',
      emptyTitle: 'Aún no hay tickets de soporte',
      emptyBody: 'Cree un ticket cuando necesite ayuda del equipo de soporte, por ejemplo con una sincronización que falla o una pregunta sobre su configuración. Todos los miembros de su organización pueden verlo y seguir su progreso aquí.',
      tabsLabel: 'Filtrar tickets',
      tabs: {
        open: 'Abiertos',
        needsReply: 'Requieren su respuesta',
        closed: 'Cerrados',
      },
      emptyTab: {
        open: 'No hay tickets abiertos. Cree un ticket nuevo cuando necesite ayuda.',
        needsReply: 'Nada requiere su respuesta en este momento.',
        closed: 'Aún no hay tickets cerrados.',
      },
      previous: 'Anterior',
      next: 'Siguiente',
      pageOf: 'Página {page} de {totalPages}',
      openedBy: 'Abierto por {name}',
      commentCount: '{count} comentarios',
      attachmentCount: '{count} archivos',
      noActivity: 'Aún sin respuestas',
      columns: {
        ticket: 'Ticket',
        type: 'Tipo',
        category: 'Categoría',
        status: 'Estado',
        lastActivity: 'Última actividad',
      },
      noCategory: '—',
      types: {
        Support: 'Soporte',
        DataWrangler: 'Data Wrangler',
      },
    },
    newTicket: {
      title: 'Nuevo ticket de soporte',
      description: 'Describa con qué necesita ayuda. Responderemos en el ticket.',
      back: 'Volver a Soporte',
      typeLabel: 'Tipo de ayuda',
      typeSupport: 'Obtener soporte',
      typeSupportDescription: 'Una pregunta o un problema con Data Mission Sync. Los errores nunca consumen horas.',
      typeWrangler: 'Data Wrangler',
      typeWranglerDescription: 'Ayuda práctica con su configuración, instalación o datos, usando las horas de su organización.',
      wranglerPartnerNote: 'Los servicios se ofrecen primero a su socio, {name}.',
      wranglerHoursNote: 'Puede enviar la solicitud sea cual sea el saldo de horas de su organización.',
      titleLabel: 'Título',
      titlePlaceholder: 'Un breve resumen del problema',
      titleRequired: 'El título es obligatorio',
      titleTooLong: 'El título debe tener {max} caracteres o menos',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Qué ocurrió, qué esperaba y los pasos para reproducirlo',
      descriptionHint: 'Incluya el nombre del perfil, la tabla y cuándo empezó aproximadamente. Las capturas de pantalla y los detalles del error son lo que más ayuda.',
      descriptionRequired: 'La descripción es obligatoria',
      attachmentsLabel: 'Archivos adjuntos (opcional)',
      attachmentsHint: 'Hasta {size} por archivo.',
      attachmentsAllowedHint: 'Tipos de archivo permitidos: {types}.',
      attachmentsBlockedHint: 'Estos tipos de archivo no se pueden adjuntar: {types}.',
      removeFile: 'Quitar {name}',
      submit: 'Crear ticket',
      submitting: 'Creando...',
      cancel: 'Cancelar',
      created: 'Ticket de soporte creado',
      createFailed: 'No se pudo crear el ticket de soporte',
      uploadsFailed: 'El ticket se creó, pero no se pudieron cargar estos archivos: {files}. Puede volver a intentarlo desde el ticket.',
    },
    coverage: {
      title: 'Quién ayuda con qué',
      supportHeading: 'Soporte de Data Rodeo',
      included: 'Incluido',
      supportBugs: 'Errores en Data Mission Sync. Los errores nunca consumen horas de nadie.',
      supportProduct: 'Cómo funcionan el producto y sus funciones.',
      supportKnowledgeBase: 'La base de conocimientos y la videoteca, incluidas en su suscripción.',
      partnerTag: 'Su socio',
      partnerSetup: 'Su configuración e instalación.',
      partnerProcesses: 'Sus procesos de negocio y todo lo que se construye alrededor de Data Mission Sync.',
      partnerServices: 'Servicios y trabajo de proyectos. Se ofrecen primero a su socio.',
      contactPartner: 'Contactar a {name}',
      wranglerHeading: 'Servicios de Data Wrangler',
      paidHours: 'Horas de pago',
      wranglerSetup: 'Su configuración, instalación y procesos alrededor de Data Mission Sync.',
      wranglerHandsOn: 'Ayuda práctica de un Data Wrangler, descontada de sus horas compradas. Las horas de Data Wrangler siempre son de pago.',
      knowledgeBase: 'Explorar la base de conocimientos',
    },
    nextSteps: {
      title: 'Qué pasa después de enviarlo',
      aiSummary: 'Agregamos un resumen de IA al principio de su ticket, a menudo con artículos que pueden ayudarle.',
      bugs: 'Los posibles errores van directamente a nuestro equipo de desarrollo.',
      partner: 'Para su configuración e instalación, {name} puede ayudarle.',
      wrangler: 'Para su configuración e instalación, un Data Wrangler puede ayudarle usando las horas de su organización.',
      waiting: 'Cuando necesitemos algo de usted, el ticket mostrará «Esperando su respuesta».',
    },
    hours: {
      title: 'Horas de Data Wrangler',
      scope: 'Para toda su organización. El tiempo dedicado a un ticket se registra en su conversación.',
      available: 'Disponibles',
      spent: 'Usadas hasta la fecha',
      assigned: 'Total compradas',
      value: '{hours} h',
      buy: 'Comprar horas',
      askAdmin: 'Pida a un administrador que compre horas.',
      loadFailed: 'No se pudieron cargar las horas.',
    },
    buyHours: {
      title: 'Comprar horas de Data Wrangler',
      description: 'Elija un paquete. Completará la compra en una página segura de Stripe y las horas se agregarán a su organización cuando se complete el pago.',
      loading: 'Cargando paquetes...',
      loadFailed: 'No se pudieron cargar los paquetes.',
      empty: 'No hay paquetes de horas disponibles en este momento.',
      packageHours: '{hours} horas',
      checkout: 'Continuar al pago',
      redirecting: 'Abriendo el pago...',
      checkoutFailed: 'No se pudo abrir la página de pago.',
      cancel: 'Cancelar',
    },
    detail: {
      back: 'Volver a Soporte',
      loadFailed: 'No se pudo cargar el ticket de soporte',
      openedBy: 'Abierto por',
      created: 'Creado',
      updated: 'Última actualización',
      resolved: 'Resuelto',
      detailsTitle: 'Detalles',
      statusLabel: 'Estado',
      type: 'Tipo de ayuda',
      resolutionCategory: 'Categoría de resolución',
      notCategorized: 'Aún sin categorizar',
      descriptionTitle: 'Descripción',
      attachmentsTitle: 'Archivos adjuntos',
      noAttachments: 'No hay archivos adjuntos.',
      addFiles: 'Agregar archivos',
      uploading: 'Cargando...',
      uploaded: 'Archivo cargado',
      uploadFailed: 'No se pudo cargar {name}',
      uploadedBy: 'Cargado por {name}',
      download: 'Descargar',
      downloadFailed: 'No se pudo descargar el archivo',
      scanning: 'Analizando',
      scanningTooltip: 'Se está comprobando si el archivo tiene virus; estará disponible en breve.',
      unavailable: 'No disponible',
      unavailableTooltip: 'El archivo no superó la comprobación de virus y no se puede descargar.',
      conversationTitle: 'Conversación',
      replyCount: '{count} respuestas · más recientes primero',
      noComments: 'Aún no hay comentarios.',
      yourTurn: 'Su turno',
      yourTurnBody: 'Soporte espera su respuesta para seguir avanzando con este ticket.',
      commentLabel: 'Responder a soporte',
      commentPlaceholder: 'Escriba una respuesta al equipo de soporte',
      commentRequired: 'El comentario es obligatorio',
      commentTooLong: 'El comentario debe tener {max} caracteres o menos',
      attachToReply: 'Adjuntar archivos',
      postComment: 'Enviar respuesta',
      posting: 'Publicando...',
      commentFailed: 'No se pudo publicar el comentario',
      showMore: 'Mostrar la respuesta completa',
      showLess: 'Mostrar menos',
      openImage: 'Abrir {name} a tamaño completo',
      imageViewerTitle: 'Vista previa del archivo adjunto',
      previousImage: 'Imagen anterior',
      nextImage: 'Imagen siguiente',
      imageCount: '{index} de {total}',
    },
    attachmentErrors: {
      tooLarge: '{name} supera {size}.',
      typeNotAllowed: '{name} no es un tipo de archivo permitido.',
      nameTooLong: 'El nombre de {name} supera los {max} caracteres.',
    },
  },
  runs: {
    runStates: {
      Completed: 'Completado',
      CompletedTooltip:
        'Sincronización completada exitosamente. Todos los datos han sido extraídos de la fuente y cargados en la base de datos de destino.',
      Failed: 'Fallido',
      FailedTooltip:
        'La sincronización encontró un error y no pudo completarse. Haga clic en la fila para ver información detallada del error.',
      Extracting: 'Extrayendo',
      ExtractingTooltip: 'Los datos se están extrayendo actualmente de la tabla de origen.',
      Loading: 'Cargando',
      LoadingTooltip: 'Los datos se están cargando actualmente en la base de datos de destino.',
      WaitingForTargetLease: 'Esperando destino',
      WaitingForTargetLeaseTooltip:
        'Esperando adquirir un bloqueo en la base de datos de destino antes de que pueda comenzar la carga.',
      WaitingForSourceCapacity: 'Esperando capacidad del origen',
      WaitingForSourceCapacityTooltip:
        'Este entorno de Dataverse alcanzó su límite de solicitudes simultáneas de Data Mission Sync. Esta tabla comenzará en cuanto se libere capacidad.',
      Scheduled: 'Programado',
      ScheduledTooltip:
        'La ejecución está esperando en la cola para ejecutarse, posiblemente porque una sincronización anterior en la tabla de origen todavía está en progreso.',
      Skipped: 'Omitido',
      SkippedTooltip:
        'La sincronización fue omitida y no se ejecutó. Haga clic en la fila para ver la razón por la que fue omitida.',
      Cancelling: 'Cancelando',
      CancellingTooltip: 'Se ha enviado una solicitud de cancelación. La sincronización se detendrá en el próximo punto de control.',
      Cancelled: 'Cancelado',
      CancelledTooltip: 'La sincronización fue cancelada manualmente o detenida antes de que pudiera completarse.',
      Unknown: 'Desconocido',
      UnknownTooltip: 'El estado de sincronización es desconocido o no pudo determinarse.',
    },
    skipReasons: {
      NoChangesDetected: 'No se detectaron cambios desde la última sincronización',
      InsufficientEntitlements: 'Derechos insuficientes para ejecutar esta sincronización',
      ObsoleteCheckpoint: 'El punto de control está obsoleto y se requiere un reinicio',
      InitialSyncAlreadyCompleted: 'La sincronización inicial ya se completó para esta tabla',
      EntityNotAvailable:
        'Esta entidad está presente en los metadatos pero no es consultable en este entorno',
    },
    syncMode: {
      Incremental: 'Incremental',
      Full: 'Completa',
      ResetAndFull: 'Reiniciar y Completa',
    },
    triggerSource: {
      Manual: 'Manual',
      Scheduled: 'Programado',
    },
    errorDialog: {
      title: 'Detalles del error de ejecución',
      runId: 'ID de ejecución',
      sourceTable: 'Tabla de origen',
      errorMessage: 'Mensaje de error',
      errorDetail: 'Detalles',
      externalErrorCode: 'Código de error externo',
      externalErrorMessage: 'Mensaje de error externo',
      close: 'Cerrar',
      unknown: 'Desconocido',
    },
    skipReasonDialog: {
      title: 'Razón de omisión de ejecución',
      runId: 'ID de ejecución',
      sourceTable: 'Tabla de origen',
      reason: 'Razón',
      close: 'Cerrar',
      unknown: 'Desconocido',
    },
  },
  sidebar: {
    navigation: 'Navegación',
    dashboard: 'Panel de control',
    profiles: 'Perfiles',
    allRuns: 'Todas las ejecuciones',
    organizationMembers: 'Miembros de la organización',
    agents: 'Agentes',
    billing: 'Facturación',
    settings: 'Configuración',
    help: 'Ayuda',
    support: 'Soporte',
    administration: 'Administración',
    sync: 'Sync',
    organizationSwitcher: {
      noOrganizations: 'Sin organizaciones',
      organization: 'Organización',
      organizationSingular: 'organización',
      organizationPlural: 'organizaciones',
      newOrganization: 'Nueva organización',
      pendingInvitations: 'Invitaciones pendientes',
      acceptInvitation: 'Aceptar invitación',
    },
    userMenu: {
      settings: 'Configuración',
      signOut: 'Cerrar sesión',
    },
  },
  dashboard: {
    title: 'Panel de control',
    description: 'Bienvenido a DataMission',
    profileActivity: 'Actividad del perfil (Últimas 24 horas)',
    createNewProfile: 'Crear nuevo perfil',
    gettingStarted: {
      title: 'Comenzar',
      description: 'Cree su primer perfil para comenzar a sincronizar datos',
      createButton: 'Crear su primer perfil',
    },
    alerts: {
      title: 'Alertas',
      loading: 'Cargando...',
      incompleteProfile: 'Configuración de perfil incompleta',
      profileMissing: 'Perfil',
      isMissing: 'le falta:',
      sourceConfiguration: 'Configuración de origen',
      targetConfiguration: 'Configuración de destino',
      completeSetup: 'Completar configuración',
    },
    entitlements: {
      title: 'Resumen de la organización',
      loading: 'Cargando...',
      profiles: 'Perfiles',
      activeAvailable: 'Activos / Disponibles',
      freeTrial: 'Prueba gratuita',
      active: 'Activo',
      inactive: 'Inactivo',
      expires: 'Expira',
      notAvailable: 'N/D',
      noActiveSubscription: 'Sin suscripción activa o prueba gratuita',
      contactSupport: 'Por favor contacte a soporte para activar su suscripción',
    },
    runSummary: {
      last24Hours: 'Últimas 24 horas',
      table: 'tabla',
      tables: 'tablas',
      noTablesConfigured: 'No hay tablas configuradas',
      sourceTables: 'Tablas de origen:',
      lastSync: 'Última sincronización:',
      nextSync: 'Próxima sincronización:',
      noRecentSyncs: 'Sin sincronizaciones recientes',
      justNow: 'Ahora mismo',
      minuteAgo: 'minuto atrás',
      minutesAgo: 'minutos atrás',
      hourAgo: 'hora atrás',
      hoursAgo: 'horas atrás',
      dayAgo: 'día atrás',
      daysAgo: 'días atrás',
      totalRuns: 'Ejecuciones totales',
      successful: 'Exitosas',
      failed: 'Fallidas',
      inProgress: 'En progreso',
      skipped: 'Omitidas',
      successRate: 'Tasa de éxito',
    },
  },
  profiles: {
    title: 'Perfiles',
    description: 'Administre sus perfiles de sincronización de datos',
    createProfile: 'Crear perfil',
    limitReached: 'Ha alcanzado el número máximo de perfiles',
    noPermission: 'No tiene permiso para crear perfiles en esta organización',
    noProfiles: 'No se encontraron perfiles. Cree su primer perfil para comenzar.',
    table: {
      name: 'Nombre',
      region: 'Región',
      lastSync: 'Última sincronización',
      nextSync: 'Próxima sincronización',
      tables: 'Tablas',
      status: 'Estado',
      quietTime: 'Tiempo de inactividad',
      edit: 'Editar',
      burstActive: 'Ráfaga activa',
    },
    status: {
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
    },
    sync: {
      noRecentSyncs: 'Sin sincronizaciones recientes',
      justNow: 'Ahora mismo',
      minutesAgo: 'm atrás',
      hoursAgo: 'h atrás',
      daysAgo: 'd atrás',
      notScheduledDisabled: 'No programado (perfil deshabilitado)',
    },
    tables: {
      noTables: 'No hay tablas configuradas',
      sourceTables: 'Tablas de origen:',
    },
    quietTime: {
      none: 'Ninguno',
      schedule: 'horario',
      schedules: 'horarios',
    },
    sourceTables: {
      title: 'Tablas de origen',
      description: 'Tablas configuradas para sincronización desde este origen',
      logicalName: 'Nombre lógico',
      status: 'Estado',
      initialSyncCompleted: 'Sincronización inicial completada',
      actions: 'Acciones',
      yes: 'Sí',
      no: 'No',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      enabledLabel: 'Habilitado',
      autoDisabled: 'Auto-deshabilitado',
      autoDisabledTitle: 'Tablas auto-deshabilitadas',
      autoDisabledDescription:
        'Una o más tablas fueron automáticamente deshabilitadas debido a fallos persistentes. Por favor revise el historial de ejecuciones en la sección inferior para identificar y resolver los problemas subyacentes antes de volver a habilitar.',
      autoDisabledTooltip: 'La tabla fue automáticamente deshabilitada debido a fallos persistentes',
      notSupported: 'No compatible',
      notSupportedTitle: 'Tablas no compatibles',
      notSupportedDescription:
        'Una o más tablas no son compatibles actualmente con el motor de sincronización. Póngase en contacto con el soporte para obtener ayuda.',
      notSupportedTooltip: 'Esta entidad no es compatible con el motor de sincronización',
      changeTrackingRequired: 'Seguimiento de cambios requerido',
      changeTrackingRequiredTitle: 'Seguimiento de cambios requerido',
      changeTrackingRequiredDescription:
        'Una o más tablas se deshabilitaron automáticamente porque el origen no puede proporcionar sus cambios hasta que se habilite el seguimiento de cambios. Para una tabla de relación (varios a varios), el seguimiento de cambios debe estar habilitado en ambas tablas relacionadas. Habilítelo en el sistema de origen y luego vuelva a habilitar la tabla.',
      changeTrackingRequiredTooltip: 'Habilite el seguimiento de cambios en el origen (en ambas tablas relacionadas para una tabla de relación) y luego vuelva a habilitar esta tabla',
      initialSync: 'Sincronización inicial',
      incrementalSync: 'Sincronización incremental',
      inventorySync: 'Sincronizar inventario',
      syncMode: 'Modo de sincronización',
      syncModeIncremental: 'Incremental',
      syncModeIncrementalTooltip:
        'El seguimiento de cambios de Dataverse entrega solo las filas modificadas desde la última sincronización.',
      syncModeIncrementalOnTooltip:
        'Solo se extraen las filas con un {field} más reciente en cada sincronización.',
      viaFieldLabel: 'via {field}',
      syncModeFull: 'Completa',
      syncModeFullTooltip:
        'No hay un campo de marca de agua disponible, por lo que cada sincronización vuelve a extraer la tabla completa.',
      deletions: 'Detección de eliminaciones',
      deletionsViaField: 'Columna',
      deletionsViaFieldTooltip:
        "Las filas eliminadas se detectan usando la columna '{field}' en cada sincronización.",
      deletionsViaInventory: 'Inventario',
      deletionsViaInventoryNextDate: 'el {date}',
      deletionsViaInventoryPendingInitialSync: 'pendiente sincronización inicial',
      deletionsViaInventoryTooltip:
        'No existe una columna de eliminación en esta entidad, por lo que una sincronización de inventario periódica reconcilia las eliminaciones comparando claves primarias.',
      deletionsPending: 'Detección pendiente',
      deletionsPendingTooltip:
        'La estrategia de eliminación se determinará después de la primera sincronización.',
      deletionsViaChangeTracking: 'Seguimiento de cambios',
      deletionsViaChangeTrackingTooltip:
        'El seguimiento de cambios de Dataverse emite eventos de eliminación de forma nativa.',
      delete: 'Eliminar',
      noTablesConfigured: 'Aún no hay tablas de origen configuradas.',
      noSearchResults: 'Ninguna tabla coincide con su búsqueda.',
      resetAndResync: 'Reiniciar y resincronizar',
      viewTargetSchema: 'Ver esquema de destino',
      setParent: 'Establecer tabla principal',
      childOf: 'Secundaria de {name}',
      parentDialogTitle: 'Establecer tabla principal',
      parentDialogDescription:
        'Subordine esta tabla a otra para que solo se sincronice una vez que su tabla principal haya terminado. Elija Ninguna para ejecutarla de forma independiente.',
      parentLabel: 'Tabla principal',
      parentNone: 'Ninguna (se ejecuta de forma independiente)',
      parentUpdateSuccess: 'Tabla principal actualizada',
      deleteTitle: 'Eliminar tabla de origen',
      deleteDescription: 'Eliminar una tabla de origen detiene las sincronizaciones futuras.',
      deleteWarning: 'Esto elimina la tabla de origen y detendrá todas las sincronizaciones futuras.',
      confirmationLabel: 'nombre de la tabla',
      successDeleted: 'Tabla de origen eliminada exitosamente',
      successReset: 'Eliminación y reinicio iniciados exitosamente',
      syncTriggeredSuccessfully: 'Sincronización iniciada exitosamente',
      tableEnabledSuccessfully: 'Tabla de origen habilitada exitosamente',
      tableDisabledSuccessfully: 'Tabla de origen deshabilitada exitosamente',
      tableDisabledSyncTooltip: 'Habilite la tabla para iniciar una sincronización',
      initialSyncInProgressTooltip: 'La sincronización inicial de esta tabla ya está en cola o en curso',
    },
    targetSchemaDialog: {
      title: 'Esquema de destino',
      availableAfterFirstSync: 'El esquema de destino está disponible después de que se complete la primera sincronización.',
      loadError: 'No se pudo cargar el esquema de destino. Inténtelo de nuevo.',
      tooLargeError: 'El esquema de esta tabla es demasiado grande para mostrarse.',
      columnName: 'Columna',
      sqlType: 'SQL Type',
      nullable: 'Admite nulos',
      primaryKey: 'Clave primaria',
      primaryKeyBadge: 'PK',
      close: 'Cerrar',
    },
    sourceCard: {
      title: 'Origen',
      description: 'Fuente de datos para este perfil',
      testing: 'Probando...',
      testConnection: 'Probar conexión',
      delete: 'Eliminar',
      noSourceAlert:
        'Se debe agregar un origen a este perfil para sincronizar datos. Use "Reanudar configuración" para configurar un origen de Dataverse.',
      type: 'Tipo',
      unknown: 'Desconocido',
      baseUrl: 'URL base',
      copyBaseUrl: 'Copiar URL base',
      notAvailable: 'N/D',
      created: 'Creado',
      connectionStatus: 'Estado de conexión',
      success: 'Éxito',
      lastTest: 'Última prueba',
      neverTested: 'Nunca probado',
      connectionSuccessful: 'Conexión exitosa',
      testSuccessful: 'Prueba de conexión exitosa',
      testFailed: 'Prueba de conexión fallida',
      copiedToClipboard: 'Copiado al portapapeles',
      failedToCopy: 'Error al copiar',
      restApiUsage: 'Uso de la API REST',
      restApiUsageLastChecked: 'Última verificación',
      restApiUsageNotAvailable: 'No disponible',
      bulkApi: 'API Bulk',
      bulkApiAvailable: 'Disponible',
      bulkApiUnavailable: 'No disponible',
    },
    targetCard: {
      title: 'Destino',
      description: 'Destino de datos para este perfil',
      testing: 'Probando...',
      testConnection: 'Probar conexión',
      delete: 'Eliminar',
      noTargetAlert:
        'Se debe agregar un destino a este perfil para sincronizar datos. Use "Reanudar configuración" para configurar un destino de Azure SQL.',
      type: 'Tipo',
      unknown: 'Desconocido',
      server: 'Servidor',
      copyServer: 'Copiar servidor',
      database: 'Base de datos',
      copyDatabase: 'Copiar base de datos',
      schema: 'Esquema',
      copySchema: 'Copiar esquema',
      tablePrefix: 'Prefijo de tabla',
      noTablePrefix: 'Ninguno',
      notAvailable: 'N/D',
      created: 'Creado',
      connectionStatus: 'Estado de conexión',
      success: 'Éxito',
      lastConnectionTest: 'Última prueba de conexión',
      neverTested: 'Nunca probado',
      nextSync: 'Próxima sincronización',
      connectionSuccessful: 'Conexión exitosa',
      testSuccessful: 'Prueba de conexión exitosa',
      testFailed: 'Prueba de conexión fallida',
      copiedToClipboard: 'Copiado al portapapeles',
      failedToCopy: 'Error al copiar',
    },
    editDialog: {
      buttonText: 'Editar perfil',
      title: 'Editar perfil',
      description: 'Actualizar información del perfil',
      name: 'Nombre',
      namePlaceholder: 'Mi perfil',
      region: 'Región',
      regionPlaceholder: 'eastus',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      save: 'Guardar cambios',
      updateSuccess: 'Perfil actualizado exitosamente',
      dataverseLengthsTitle: 'Longitudes de columnas de Dataverse',
      dataverseLengthsDescription:
        'Longitudes máximas para las columnas de etiqueta y de selección múltiple de Dataverse. Los cambios se aplican en el próximo restablecimiento completo y resincronización de cada tabla.',
      lookupLabelLength: 'Etiqueta de búsqueda',
      choiceLabelLength: 'Etiqueta de opción',
      multiSelectLength: 'Selección múltiple',
      lengthReduceWarning:
        'Reducir una longitud puede truncar los valores existentes en el próximo restablecimiento. Recuperable aumentándola y resincronizando.',
    },
    syncSettings: {
      buttonText: 'Configuración de sincronización',
      title: 'Configuración de sincronización',
      description: 'Configure el comportamiento de sincronización para este perfil.',
      deleteModeLabel: 'Modo de eliminación',
      warningTitle: 'Advertencia: Esto puede causar pérdida de datos',
      warningDescription:
        'Cambiar el modo de eliminación después de la sincronización inicial puede resultar en inconsistencias o pérdida de datos. Los registros que fueron eliminados de forma lógica pueden ser eliminados permanentemente, o los registros eliminados físicamente pueden no ser rastreados correctamente.',
      acknowledgeChange: 'Entiendo que esto puede causar pérdida de datos y deseo continuar',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando...',
      updateSuccess: 'Configuración de sincronización actualizada exitosamente',
    },
  },
  syncButton: {
    sync: 'Sincronizar',
    syncing: 'Sincronizando...',
    incrementalSync: 'Sincronización incremental',
    resetAndFullSync: 'Reiniciar + Sincronización completa',
  },
  profileDetail: {
    outboundIp: 'IP de salida',
    status: {
      active: 'Activo',
      paused: 'Pausado',
    },
    actions: {
      copyProfileId: 'Copiar ID del perfil',
      help: 'Ayuda',
      updating: 'Actualizando...',
      disable: 'Deshabilitar',
      enable: 'Habilitar',
      enabled: 'Habilitado',
      syncing: 'Sincronizando...',
      sync: 'Sincronizar',
      resetFullSync: 'Reiniciar + Sincronización completa',
      triggerInitialSync: 'Iniciar sincronización inicial',
      resumeSetup: 'Reanudar configuración',
      editProfile: 'Editar perfil',
      deleteProfile: 'Eliminar perfil',
      actions: 'Acciones',
      syncDisabledTooltip: 'Habilite el perfil para iniciar una sincronización',
    },
    quietTime: {
      title: 'Períodos de tiempo de inactividad',
      description: 'Las sincronizaciones se omitirán durante estas ventanas de tiempo',
      addQuietTimeBlock: 'Agregar bloque de tiempo de inactividad',
      loadingSchedules: 'Cargando horarios...',
      noSchedules: 'No hay horarios de tiempo de inactividad configurados',
      recurrence: 'Recurrencia',
      startTime: 'Hora de inicio',
      endTime: 'Hora de fin',
      daily: 'Diario',
      noDaysSelected: 'No hay días seleccionados',
    },
    createScheduleDialog: {
      title: 'Agregar nuevo bloque de tiempo de inactividad',
      description: 'Todos los horarios están en UTC. Las sincronizaciones se omitirán durante estas ventanas de tiempo.',
      type: 'Tipo',
      everyDay: 'Todos los días',
      specificDays: 'Días específicos',
      selectDays: 'Seleccionar días',
      startTime: 'Hora de inicio (UTC)',
      endTime: 'Hora de fin (UTC)',
      hourPlaceholder: 'HH',
      minutePlaceholder: 'MM',
      durationError: 'El tiempo de inactividad no debe exceder 8 horas.',
      cancel: 'Cancelar',
      creating: 'Creando...',
      create: 'Crear horario',
      createSuccess: 'Horario creado exitosamente',
      createError: 'Error al crear horario',
    },
    burst: {
      menuItem: 'Ráfaga de sincronización',
      title: 'Ráfaga de sincronización',
      description:
        'Ejecuta temporalmente este perfil con una cadencia de sincronización acelerada. Los períodos de silencio se siguen respetando.',
      windowLabel: 'Ventana de ráfaga (horas)',
      windowHelp:
        'Se ejecuta con una sincronización acelerada de 5 minutos durante un máximo de {max} horas y luego vuelve a la programación normal.',
      activeUntil: 'Ráfaga activa hasta {time}.',
      activeBadge: 'Ráfaga activa',
      overlapWarning:
        'Esta ventana de ráfaga se superpone con un período de silencio; las sincronizaciones se siguen omitiendo durante el silencio.',
      activate: 'Activar ráfaga',
      stop: 'Detener ráfaga',
      cancel: 'Cancelar',
      activateSuccess: 'Ráfaga activada',
      activateError: 'Error al activar la ráfaga',
      stopSuccess: 'Ráfaga detenida',
      stopError: 'Error al detener la ráfaga',
    },
    daysOfWeek: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
    },
    runHistory: {
      title: 'Historial de ejecuciones',
      description: 'Ver ejecuciones de sincronización para este perfil',
      recentRuns: 'Ejecuciones recientes',
    },
    errors: {
      failedToLoad: 'Error al cargar perfil',
      copiedToClipboard: 'Copiado al portapapeles',
      failedToCopy: 'Error al copiar',
      profileEnabled: 'Perfil habilitado exitosamente',
      profileDisabled: 'Perfil deshabilitado exitosamente',
      syncTriggered: 'Sincronización iniciada exitosamente',
      failedToLoadRuns: 'Error al cargar ejecuciones',
    },
    helpContent: {
      profileHelp: 'Ayuda del perfil',
      profileHelpDescription: 'Aprenda sobre la gestión de perfiles, sincronizaciones e historial de ejecuciones',
      setupChecklistTitle: 'Lista de verificación de configuración del perfil',
      setupChecklistDescription: 'Siga el progreso de configuración de su perfil',
      checklistItems: {
        configureSource: 'Configurar origen',
        configureTarget: 'Configurar destino',
        selectTables: 'Seleccionar tablas para sincronizar',
        configureQuietTime: 'Configurar tiempo de inactividad',
        configureDeleteMode: 'Configurar modo de eliminación',
        runInitialSync: 'Ejecutar sincronización inicial',
      },
      allStepsCompleted: '✓ ¡Todos los pasos de configuración completados! Su perfil está listo para sincronizar.',
      profileStatus: {
        title: 'Estado del perfil',
        active: 'Activo:',
        activeDescription: 'El perfil está habilitado y puede ejecutar sincronizaciones programadas',
        paused: 'Pausado:',
        pausedDescription: 'El perfil está deshabilitado y las sincronizaciones no se ejecutarán',
      },
      syncActions: {
        title: 'Acciones de sincronización',
        sync: 'Sincronizar:',
        syncDescription: 'Realiza una sincronización incremental, solo procesando datos nuevos o modificados',
        resetFullSync: 'Reiniciar + Sincronización completa:',
        resetFullSyncDescription:
          'Elimina todos los datos existentes y realiza una sincronización completa desde el origen. Esta es una operación destructiva.',
        triggerInitialSync: 'Iniciar sincronización inicial:',
        triggerInitialSyncDescription:
          'Ejecuta la primera sincronización después de configurar su origen y destino',
      },
      sourceAndTarget: {
        title: 'Origen y destino',
        source: 'Origen:',
        sourceDescription: 'La fuente de datos de donde provienen sus datos',
        target: 'Destino:',
        targetDescription: 'El destino donde se almacenarán los datos sincronizados',
        configurationNote: 'Tanto el origen como el destino deben estar configurados antes de poder iniciar sincronizaciones',
      },
      quietTimePeriods: {
        title: 'Períodos de tiempo de inactividad',
        description:
          'Configure ventanas de tiempo cuando las sincronizaciones se omitirán automáticamente. Esto es útil para evitar sincronizaciones durante ventanas de mantenimiento o tiempos de uso pico.',
      },
      runHistory: {
        title: 'Historial de ejecuciones',
        viewAllRuns:
          'Ver todas las ejecuciones de sincronización para este perfil, incluyendo su estado, duración y resultados',
        filterRuns: 'Filtrar ejecuciones por estado (Completado, Fallido, etc.) o por tabla de origen',
        clickFailedRuns: 'Haga clic en las ejecuciones fallidas para ver información detallada del error',
        usePagination: 'Use los controles de paginación para navegar por las ejecuciones históricas',
      },
      runStates: {
        title: 'Estados de ejecución',
        completed: 'Completado:',
        completedDescription: 'La sincronización finalizó exitosamente',
        failed: 'Fallido:',
        failedDescription: 'La sincronización encontró un error',
        extractingLoading: 'Extrayendo/Cargando:',
        extractingLoadingDescription: 'La sincronización está en progreso',
        scheduled: 'Programado:',
        scheduledDescription: 'La sincronización está en cola para ejecutarse',
        skipped: 'Omitido:',
        skippedDescription: 'La sincronización fue omitida (ej., debido al período de tiempo de inactividad)',
        cancelled: 'Cancelado:',
        cancelledDescription: 'La sincronización fue cancelada',
      },
    },
  },
  settings: {
    title: 'Configuración',
    description: 'Administre la configuración y preferencias de su cuenta',
    profileInfo: {
      title: 'Información del perfil',
      description:
        'Actualice su información personal. Esto se mostrará en toda la aplicación.',
    },
    fields: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      emailNote: 'El correo electrónico no se puede cambiar',
    },
    actions: {
      save: 'Guardar cambios',
      saving: 'Guardando...',
    },
    language: {
      label: 'Idioma',
      description: 'Seleccione su idioma preferido para la interfaz de la aplicación.',
      english: 'Inglés',
      french: 'Francés',
      german: 'Alemán',
      spanish: 'Español',
    },
    appearance: {
      title: 'Apariencia',
      description: 'Personalice el tema de la aplicación.',
      themeLabel: 'Tema',
      themeDescription: 'Elija modo claro, oscuro o del sistema.',
      toggleTheme: 'Cambiar tema',
      themeOptions: {
        light: 'Claro',
        dark: 'Oscuro',
        system: 'Sistema',
      },
    },
    notifications: {
      updateSuccess: 'Perfil actualizado exitosamente',
      updateError: 'Error al actualizar el perfil. Por favor intente de nuevo.',
    },
    emailNotifications: {
      title: 'Notificaciones por correo electrónico',
      description: 'Elija qué notificaciones por correo electrónico desea recibir.',
      save: 'Guardar preferencias',
      saving: 'Guardando...',
      updateSuccess: 'Preferencias de notificación actualizadas exitosamente',
      updateError: 'Error al actualizar las preferencias de notificación. Por favor intente de nuevo.',
      sections: {
        general: 'General',
        billing: 'Facturación',
        dataMission: 'Data Mission',
        marketing: 'Marketing',
      },
      events: {
        UserInvited: {
          label: 'Invitaciones de organización',
          description: 'Recibir un correo electrónico cuando sea invitado a unirse a una organización.',
        },
        TrialConsumed: {
          label: 'Prueba activada',
          description:
            'Recibir un correo electrónico cuando se active una prueba de producto, incluyendo la duración y fecha de finalización de la prueba.',
        },
        PaymentFailed: {
          label: 'Pago fallido',
          description: 'Recibir un correo electrónico cuando falle un intento de pago.',
        },
        BillingReminder: {
          label: 'Recordatorios de facturación',
          description: 'Recibir recordatorios sobre facturación próxima.',
        },
        PaymentMethodChanged: {
          label: 'Método de pago actualizado',
          description: 'Recibir un correo electrónico cuando se actualice su método de pago.',
        },
        SubscriptionCanceled: {
          label: 'Suscripción cancelada',
          description: 'Recibir un correo electrónico cuando se cancele una suscripción.',
        },
        SubscriptionSuspended: {
          label: 'Suscripción suspendida',
          description: 'Recibir un correo electrónico cuando una suscripción sea suspendida debido a problemas de pago.',
        },
        DataMissionSyncFailed: {
          label: 'Fallos de sincronización',
          description:
            'Recibir un correo electrónico cuando una tabla de origen falle al sincronizar exitosamente en Data Mission.',
        },
        ProductUpdates: {
          label: 'Actualizaciones de productos, funciones y servicios',
          description: 'Manténgase informado sobre nuevas funciones, actualizaciones de productos y mejoras de servicio.',
        },
        NewsTrainingArticles: {
          label: 'Noticias, capacitación y artículos',
          description: 'Le enviaremos correos electrónicos con noticias, actualizaciones de capacitación y artículos útiles sobre Data Mission Sync.',
        },
      },
    },
    orgSettings: {
      title: 'Configuración de la organización',
      description: 'Configure las preferencias y valores predeterminados a nivel de organización',
      organizationName: 'Nombre de la organización',
      organizationNameDescription: 'El nombre visible de esta organización',
      organizationNameRequired: 'El nombre de la organización es obligatorio',
      billingCountry: 'País de facturación',
      billingCountryDescriptionSet: 'El país de facturación para esta organización (no se puede cambiar)',
      billingCountryDescriptionNotSet: 'Seleccione el país de facturación para esta organización (no se puede cambiar una vez establecido)',
      defaultRegion: 'Región predeterminada',
      defaultRegionDescription: 'La región de Azure predeterminada para nuevos perfiles en esta organización',
      noDefaultRegion: 'Sin región predeterminada',
      save: 'Guardar configuración de organización',
      saving: 'Guardando...',
      updateSuccess: 'Configuración de organización actualizada exitosamente',
      updateError: 'Error al actualizar la configuración de la organización',
      noOrganizationSelected: 'No hay organización seleccionada',
    },
    featureFlags: {
      title: 'Indicadores de funcionalidades',
      description: 'Activar o desactivar funcionalidades para esta organización.',
    },
    legalDocuments: {
      title: 'Documentos legales',
      description: 'Revise el estado de aceptación de nuestros documentos legales.',
      privacyPolicy: 'Política de privacidad',
      termsOfUse: 'Términos de uso',
      currentVersion: 'Versión actual',
      acceptedOn: 'Aceptado el',
      neverAccepted: 'Aún no aceptado',
      view: 'Ver',
      close: 'Cerrar',
      version: 'Versión',
    },
  },
  targets: {
    createDialog: {
      title: 'Crear destino de Azure SQL',
      description: 'Agregar una nueva base de datos de destino de Azure SQL a este perfil',
      addTarget: 'Agregar destino',
      onlyOneTargetTooltip:
        'Solo un destino por perfil. Elimine el destino existente para crear uno nuevo.',
      targetType: 'Tipo de destino',
      targetTypeDescription: 'Actualmente solo se admiten destinos de Azure SQL Database',
      authType: 'Tipo de autenticación',
      authTypeServicePrincipal: 'Principal de servicio (AAD)',
      authTypeServicePrincipalDescription:
        'Autenticar usando credenciales de principal de servicio de Azure AD',
      authTypeSqlCredential: 'Credenciales SQL',
      authTypeSqlCredentialDescription:
        'Autenticar usando un nombre de usuario y contraseña de SQL',
      useSourceClientId: 'Usar ID de cliente del origen',
      useSourceClientIdDescription:
        "Copiar el ID de cliente del origen. Aún necesitará proporcionar el ID de inquilino y el secreto del cliente.",
      usingClientIdFromSource: 'Usando ID de cliente del origen',
      tenantId: 'ID de inquilino',
      tenantIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      tenantIdDescription: 'El ID de inquilino de Azure AD',
      clientId: 'ID de cliente',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: 'El ID de aplicación (cliente) de Azure AD',
      clientSecret: 'Secreto del cliente',
      clientSecretPlaceholder: 'Ingrese el secreto del cliente',
      clientSecretDescription: 'El secreto del cliente de la aplicación de Azure AD',
      username: 'Nombre de usuario',
      usernamePlaceholder: 'Ingrese el nombre de usuario SQL',
      usernameDescription: 'El nombre de usuario de inicio de sesión de SQL Server',
      password: 'Contraseña',
      passwordPlaceholder: 'Ingrese la contraseña SQL',
      passwordDescription: 'La contraseña de inicio de sesión de SQL Server',
      encryptConnection: 'Cifrar conexión',
      encryptConnectionDescription: 'Desactivar si se conecta a un SQL Server local sin TLS configurado',
      server: 'Servidor',
      serverPlaceholder: 'miservidor.database.windows.net',
      serverDescription: 'Nombre del servidor de Azure SQL (ej., miservidor.database.windows.net)',
      database: 'Base de datos',
      databasePlaceholder: 'MiBaseDeDatos',
      databaseDescription: 'Nombre de la base de datos de destino',
      schema: 'Esquema',
      schemaPlaceholder: 'dbo',
      schemaDescription: "Nombre del esquema SQL (por defecto 'dbo')",
      agent: 'Agente',
      agentPlaceholder: 'Seleccionar un agente',
      agentDescription: 'Asignar opcionalmente un agente auto-hospedado para ejecutar las operaciones de sincronización de este destino',
      agentNone: 'Ninguno (hospedado en la nube)',
      connectionTest: 'Prueba de conexión',
      testConnection: 'Probar conexión',
      testing: 'Probando...',
      testDescription: 'Pruebe su conexión antes de crear el destino',
      connectionSuccessful: 'Conexión exitosa',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando...',
      saveAndCreateSource: 'Guardar y crear origen',
      allFieldsRequired: 'Todos los campos son requeridos para probar la conexión',
      validationFailed: 'Validación fallida. Por favor verifique el formulario.',
    },
    editDialog: {
      buttonText: 'Editar destino',
      title: 'Editar destino',
      description: 'Actualizar la configuración del destino',
      tenantId: 'ID de inquilino',
      tenantIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      tenantIdDescription: 'El ID de inquilino de Azure AD',
      clientId: 'ID de cliente',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: 'El ID de aplicación (cliente) de Azure AD',
      clientSecret: 'Secreto del cliente',
      clientSecretPlaceholder: 'Ingrese el secreto del cliente',
      clientSecretDescription: 'El secreto del cliente de la aplicación de Azure AD',
      tenantIdRequired: 'El ID de inquilino es requerido',
      clientIdRequired: 'El ID de cliente es requerido',
      clientSecretRequired: 'El secreto del cliente es requerido',
      usernameRequired: 'El nombre de usuario es requerido',
      passwordRequired: 'La contraseña es requerida',
      username: 'Nombre de usuario',
      usernamePlaceholder: 'Ingrese el nombre de usuario SQL',
      usernameDescription: 'El nombre de usuario de inicio de sesión de SQL Server',
      password: 'Contraseña',
      passwordPlaceholder: 'Ingrese la contraseña SQL',
      passwordDescription: 'La contraseña de inicio de sesión de SQL Server',
      encryptConnection: 'Cifrar conexión',
      encryptConnectionDescription: 'Desactivar si se conecta a un SQL Server local sin TLS configurado',
      cancel: 'Cancelar',
      update: 'Actualizar',
      updateSuccess: 'Destino actualizado exitosamente',
      agent: 'Agente',
      agentPlaceholder: 'Seleccionar un agente',
      agentDescription: 'Asignar un agente auto-hospedado para ejecutar las operaciones de sincronización de este destino',
      agentNone: 'Ninguno (hospedado en la nube)',
      testConnection: 'Probar conexión',
      connectionSuccessful: 'Conexión exitosa',
    },
    prefixDialog: {
      buttonText: 'Cambiar prefijo de tabla',
      title: 'Cambiar prefijo de tabla',
      description: 'El prefijo de tabla se aplica a cada tabla que crea este perfil.',
      label: 'Prefijo de tabla',
      placeholder: 'ej. dms_',
      hint: 'Solo letras, dígitos y guiones bajos. Deje vacío para no usar prefijo.',
      invalidPrefix: 'El prefijo de tabla solo puede contener letras, dígitos y guiones bajos.',
      tablesTooLong: 'Algunas tablas no pueden usar este prefijo porque su nombre superaría el límite de 128 caracteres de SQL:',
      warningTitle: 'Esto eliminará y reconstruirá todas las tablas sincronizadas',
      warningOperation1: 'Se eliminan todas las tablas de destino (finales y de preparación) de este perfil.',
      warningOperation2: 'Se recrean con el nuevo prefijo y se vuelven a sincronizar desde cero.',
      warningOperation3: 'Los datos sincronizados no estarán disponibles hasta que se complete la resincronización.',
      acknowledge: 'Entiendo que todas las tablas sincronizadas se eliminarán y reconstruirán.',
      cancel: 'Cancelar',
      apply: 'Cambiar prefijo',
      updateSuccess: 'Prefijo de tabla actualizado',
    },
    notifications: {
      createSuccess: 'Destino creado exitosamente',
      createError: 'Error al crear el destino. Por favor intente de nuevo.',
    },
  },
  sources: {
    pageSizeField: {
      label: 'Tamaño de página',
      description: 'Filas obtenidas por solicitud de extracción ({min}–{max}). Los valores más altos implican menos llamadas.',
    },
    createDialog: {
      title: 'Crear origen de Dataverse',
      description: 'Agregar una nueva fuente de datos de Dataverse a este perfil',
      addSource: 'Agregar origen',
      onlyOneSourceTooltip:
        'Solo un origen por perfil. Elimine el origen existente para crear uno nuevo.',
      sourceType: 'Tipo de origen',
      sourceTypeDescription: 'Actualmente solo se admiten orígenes de Microsoft Dataverse',
      baseUrl: 'URL base',
      baseUrlPlaceholder: 'https://org.crm.dynamics.com',
      baseUrlDescription: 'La URL HTTPS a su punto de conexión de API de Dataverse',
      clientId: 'ID de cliente',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: 'El ID de aplicación (cliente) de Azure AD',
      clientSecret: 'Secreto del cliente',
      clientSecretPlaceholder: 'Ingrese el secreto del cliente',
      clientSecretDescription: 'El secreto del cliente de la aplicación de Azure AD',
      connectionTest: 'Prueba de conexión',
      testConnection: 'Probar conexión',
      testing: 'Probando conexión...',
      testDescription: 'Pruebe su conexión antes de crear el origen',
      connectionSuccessful: 'Conexión exitosa',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando...',
      saveAndCreateTarget: 'Guardar y crear destino',
      allFieldsRequired: 'Todos los campos son requeridos para probar la conexión',
      validationFailed: 'Validación fallida. Por favor verifique el formulario.',
    },
    editDialog: {
      buttonText: 'Editar origen',
      title: 'Editar origen',
      description: 'Actualizar la configuración del origen',
      baseUrl: 'URL base',
      baseUrlDescription: 'La URL HTTPS a su punto de conexión de API de Dataverse',
      pageSize: 'Tamaño de página',
      pageSizeDescription: 'Registros obtenidos por llamada a la API de Dataverse (1000–5000). Redúzcalo si las tablas muy anchas agotan el tiempo de espera; auméntelo para reducir las llamadas a la API. Predeterminado 3000.',
      pageSizeRange: 'El tamaño de página debe estar entre 1000 y 5000',
      clientId: 'ID de cliente',
      clientIdDescription: 'El ID de aplicación (cliente) de Azure AD',
      clientSecret: 'Secreto del cliente',
      clientSecretDescription: 'El secreto del cliente de la aplicación de Azure AD',
      consumerKey: 'Clave de consumidor',
      consumerKeyDescription: 'La clave de consumidor de su aplicación conectada de Salesforce',
      secret: 'Secreto',
      secretDescription: 'El secreto de consumidor de su aplicación conectada de Salesforce',
      baseUrlRequired: 'La URL base es requerida',
      clientIdRequired: 'El ID de cliente es requerido',
      clientSecretRequired: 'El secreto del cliente es requerido',
      consumerKeyRequired: 'La clave de consumidor es requerida',
      secretRequired: 'El secreto es requerido',
      instanceUrlRequired: 'La URL de instancia es requerida',
      tenantIdRequired: 'El ID de inquilino es requerido',
      environmentRequired: 'El entorno es requerido',
      companyRequired: 'Por favor seleccione una empresa después de probar la conexión',
      testConnection: 'Probar conexión',
      connectionSuccessful: 'Conexión exitosa',
      cancel: 'Cancelar',
      updating: 'Actualizando...',
      update: 'Actualizar origen',
      updateSuccess: 'Origen actualizado exitosamente',
    },
    sourceTablesDialog: {
      buttonText: 'Agregar tabla de origen',
      title: 'Agregar tablas de origen',
      description: 'Seleccione una o más tablas de este origen para sincronizar',
      tables: 'Tablas',
      selected: 'seleccionadas',
      selectAll: 'Seleccionar todo',
      deselectAll: 'Deseleccionar todo',
      searchPlaceholder: 'Buscar tablas...',
      loading: 'Cargando tablas...',
      noTables: 'No se encontraron tablas',
      selectAtLeastOne: 'Por favor seleccione al menos una tabla',
      cancel: 'Cancelar',
      adding: 'Agregando...',
      addTables: 'Agregar',
      addSuccess: '¡Tablas de origen agregadas exitosamente!',
      timestampField: 'Elija un campo de marca de tiempo para sincronizaciones incrementales',
      timestampFieldDescription: 'Campo utilizado para sincronización incremental',
      timestampFieldNone: 'Ninguno (replicación completa)',
      incrementalSyncVia: 'Sincronización incremental mediante {field}',
      fullReplication: 'Replicación completa (no hay campo de marca de tiempo disponible)',
      noTimestampFieldNotice: 'No hay columnas de marca de tiempo disponibles para esta tabla. Cada sincronización realizará una replicación completa de todos los registros.',
      nameTooLongForPrefix: 'Nombre demasiado largo para el prefijo de tabla de este perfil.',
    },
    tableBatch: {
      progress: 'Agregando {done} de {total}...',
      partialFailure: 'Se agregaron {added} de {total} tablas. No se pudieron agregar {failed}:',
      moreTables: '(+{count} más)',
      syncStartFailed: 'Se agregaron {count} tablas, pero no se pudo iniciar su sincronización inicial. Inicie una sincronización desde la página del perfil.',
    },
    tablePaste: {
      open: 'Pegar lista de tablas',
      description: 'Pegue los nombres lógicos de las tablas, uno por línea o separados por comas. La coincidencia no distingue mayúsculas de minúsculas.',
      placeholder: 'account\ncontact\nmsdyn_matchingcriteria',
      resolve: 'Seleccionar tablas coincidentes',
      cancel: 'Cancelar',
      emptyInput: 'Pegue al menos un nombre de tabla.',
      summary: '{selected} seleccionadas, {alreadySelected} ya seleccionadas, {alreadyAdded} ya agregadas, {notSyncable} no sincronizables, {notFound} no encontradas.',
      columnTable: 'Tabla',
      columnResult: 'Resultado',
      columnDetails: 'Detalles',
      resultAlreadyAdded: 'Ya agregada',
      alreadyAddedDetail: 'Esta tabla ya está agregada a este perfil.',
      resultNotSyncable: 'No sincronizable',
      resultNotFound: 'No encontrada',
      didYouMean: '¿Quiso decir {name}?',
      noMatch: 'No existe ninguna tabla con este nombre lógico en el origen.',
      copyUnresolved: 'Copiar nombres no resueltos',
      copySelected: 'Copiar selección',
      copied: 'Copiado',
      dismiss: 'Cerrar',
    },
    sourceCapacity: {
      queuedTitle: 'Tablas en espera de capacidad de Dataverse',
      queuedDescription:
        '{count} tablas están en espera de capacidad de Dataverse (límite: {limit} solicitudes simultáneas por entorno). Las sincronizaciones se completarán, solo que más despacio.',
      manyTablesHint:
        'Las sincronizaciones de este entorno de Dataverse ejecutan hasta {limit} solicitudes a la vez. Con {count} tablas, las sincronizaciones grandes quedarán en cola y tardarán más en completarse.',
      selectionHint:
        'Las sincronizaciones de este entorno de Dataverse ejecutan hasta {limit} solicitudes a la vez. Con {count} tablas seleccionadas, la sincronización inicial quedará en cola y tardará más en completarse.',
      dedicatedAppNote:
        'Use un registro de aplicación dedicado a Data Mission Sync. Dataverse limita las solicitudes simultáneas por usuario de aplicación, por lo que compartirlo con otras integraciones puede provocar limitaciones.',
    },
    notifications: {
      createSuccess: 'Origen creado exitosamente',
      createError: 'Error al crear el origen. Por favor intente de nuevo.',
    },
  },
  wizard: {
    advancedSettings: {
      title: 'Configuración avanzada',
      description: 'Opcional. La mayoría de los clientes pueden dejar esto como está.',
    },
    steps: {
      profile: 'Perfil',
      source: 'Origen',
      target: 'Destino',
      tables: 'Tablas',
      quietTime: 'Tiempo de inactividad',
      deleteMode: 'Modo de eliminación',
      initialSync: 'Sincronización inicial',
    },
    availableTableDisabledReasons: {
      ChangeTrackingDisabled: 'Habilite el seguimiento de cambios para usar esta entidad.',
      NotSupported: 'Esta entidad no está disponible actualmente. Póngase en contacto con el soporte para obtener ayuda.',
      RelatedChangeTrackingDisabled: 'Habilite el seguimiento de cambios en ambas tablas relacionadas para usar esta tabla de relación.',
      VirtualTable: 'Esta es una tabla virtual: sus datos no se almacenan en Dataverse, por lo que no se puede sincronizar.',
    },
    common: {
      back: 'Atrás',
      next: 'Siguiente',
      cancel: 'Cancelar',
      create: 'Crear',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Agregar',
      remove: 'Eliminar',
      update: 'Actualizar',
      submit: 'Enviar',
      close: 'Cerrar',
      copy: 'Copiar',
      copied: 'Copiado',
      copyToClipboard: 'Copiado al portapapeles',
      failedToCopy: 'Error al copiar',
    },
    profile: {
      title: 'Crear perfil',
      titleEdit: 'Detalles del perfil',
      description: 'Configure un nuevo perfil de sincronización de datos',
      descriptionEdit: 'Ver la configuración de su perfil',
      cardTitle: 'Detalles del perfil',
      cardDescription: 'Configure los ajustes básicos para su perfil',
      profileName: 'Nombre del perfil',
      profileNamePlaceholder: 'Mi perfil de sincronización de datos',
      region: 'Región',
      regionPlaceholder: 'Seleccione una región',
      creating: 'Creando...',
      nextConfigureSource: 'Siguiente: Configurar origen',
      profileCreatedSuccessfully: 'Perfil creado exitosamente',
      pleaseEnterProfileName: 'Por favor ingrese un nombre de perfil',
      advancedLengthsInvalid: 'Las longitudes de columna de Dataverse deben estar entre 50 y 4000.',
    },
    source: {
      title: 'Configurar origen',
      description: 'Conectar a su fuente de datos',
      cardTitle: 'Detalles de conexión',
      cardDescription: 'Ingrese sus credenciales y detalles de conexión',
      sourceType: 'Tipo de origen',
      selectSourceType: 'Seleccione un tipo de origen',
      dataverse: 'Dataverse',
      businessCentral: 'Business Central',
      salesforce: 'Salesforce',
      baseUrl: 'URL base',
      baseUrlPlaceholder: 'https://suorg.crm.dynamics.com',
      pageSize: 'Tamaño de página',
      pageSizePlaceholder: '3000',
      pageSizeDescription: 'Registros obtenidos por llamada a la API de Dataverse (1000–5000). Redúzcalo si las tablas muy anchas agotan el tiempo de espera; auméntelo para reducir las llamadas a la API. Predeterminado 3000.',
      pageSizeRange: 'El tamaño de página debe estar entre 1000 y 5000',
      tenantId: 'ID de inquilino',
      tenantIdPlaceholder: 'Ingrese el ID de inquilino de Azure AD',
      bcEnvironment: 'Entorno',
      bcEnvironmentPlaceholder: 'ej. production',
      instanceUrl: 'URL de instancia',
      instanceUrlPlaceholder: 'https://mycompany.my.salesforce.com',
      isSandbox: 'Organización sandbox',
      isSandboxDescription: 'Activar si este es un entorno sandbox de Salesforce',
      clientId: 'ID de cliente',
      clientIdPlaceholder: 'Ingrese el ID de cliente',
      clientSecret: 'Secreto del cliente',
      clientSecretPlaceholder: 'Ingrese el secreto del cliente',
      consumerKey: 'Clave de consumidor',
      consumerKeyPlaceholder: 'Ingrese la clave de consumidor',
      secret: 'Secreto',
      secretPlaceholder: 'Ingrese el secreto',
      testConnection: 'Probar conexión',
      testConnectionAndLoadCompanies: 'Probar conexión y cargar empresas',
      testing: 'Probando conexión...',
      connectionSuccessful: 'Conexión exitosa',
      company: 'Empresa',
      companyPlaceholder: 'Seleccionar empresa',
      noCompaniesFound: 'No se encontraron empresas',
      allFieldsRequired: 'Todos los campos son requeridos para probar la conexión',
      testBeforeProceeding: 'Por favor pruebe la conexión exitosamente antes de continuar',
      selectCompanyBeforeProceeding: 'Por favor seleccione una empresa antes de continuar',
      back: 'Atrás',
      next: 'Siguiente: Configurar destino',
      creating: 'Creando...',
    },
    target: {
      title: 'Configurar destino',
      description: 'Conectar a su base de datos de Azure SQL',
      cardTitle: 'Conexión a Azure SQL',
      cardDescription: 'Ingrese sus credenciales y detalles de la base de datos de Azure SQL',
      warning: 'Advertencia: Después de la primera sincronización, el destino no se puede cambiar.',
      firewallTitle: 'Configuración de firewall requerida',
      firewallDescription:
        'Para permitir que Data Mission se conecte a su servidor Azure SQL, elija una de estas opciones:',
      firewallOptionAzure:
        'Habilite "Permitir que los servicios y recursos de Azure accedan a este servidor" en la configuración de red de su servidor Azure SQL.',
      firewallOptionAzureLabel: 'Opción 2:',
      firewallOptionIpRecommended: 'Opción 1 (Recomendada):',
      firewallOptionIpDescription:
        'Agregue la siguiente dirección IP estática a las reglas de firewall de su servidor Azure SQL:',
      firewallIpUnavailable:
        'IP estática no disponible para esta región. Use la Opción 1 en su lugar.',
      firewallSummary:
        'Es posible que se requiera configuración de red adicional para permitir que nuestros servicios accedan a su servidor Azure SQL.',
      firewallLearnMore: 'Más información',
      firewallClose: 'Cerrar',
      authType: 'Tipo de autenticación',
      authTypeServicePrincipal: 'Principal de servicio (AAD)',
      authTypeServicePrincipalDescription:
        'Autenticar usando credenciales de principal de servicio de Azure AD',
      authTypeSqlCredential: 'Credenciales SQL',
      authTypeSqlCredentialDescription:
        'Autenticar usando un nombre de usuario y contraseña de SQL',
      useSourceClientId: 'Usar ID de cliente del origen',
      useSourceClientIdDescription:
        "Copiar el ID de cliente del origen. Aún necesitará proporcionar el ID de inquilino y el secreto del cliente.",
      usingClientIdFromSource: 'Usando ID de cliente del origen',
      tenantId: 'ID de inquilino',
      tenantIdPlaceholder: 'Ingrese el ID de inquilino',
      clientId: 'ID de cliente',
      clientIdPlaceholder: 'Ingrese el ID de cliente',
      clientSecret: 'Secreto del cliente',
      clientSecretPlaceholder: 'Ingrese el secreto del cliente',
      username: 'Nombre de usuario',
      usernamePlaceholder: 'Ingrese el nombre de usuario SQL',
      usernameDescription: 'El nombre de usuario de inicio de sesión de SQL Server',
      password: 'Contraseña',
      passwordPlaceholder: 'Ingrese la contraseña SQL',
      passwordDescription: 'La contraseña de inicio de sesión de SQL Server',
      encryptConnection: 'Cifrar conexión',
      encryptConnectionDescription: 'Desactivar si se conecta a un SQL Server local sin TLS configurado',
      server: 'Servidor',
      serverPlaceholder: 'suservidor.database.windows.net',
      database: 'Base de datos',
      databasePlaceholder: 'Ingrese el nombre de la base de datos',
      schema: 'Nombre del esquema',
      schemaPlaceholder: 'dbo',
      tablePrefix: 'Prefijo de tabla (opcional)',
      tablePrefixPlaceholder: 'ej. dms_',
      tablePrefixDescription: 'Se aplica a cada tabla que crea este perfil (ej. dms_account). Incluya su propio separador. Solo letras, dígitos y guiones bajos.',
      tablePrefixInvalid: 'El prefijo de tabla solo puede contener letras, dígitos y guiones bajos.',
      agent: 'Agente',
      agentPlaceholder: 'Seleccionar un agente',
      agentDescription: 'Asignar opcionalmente un agente auto-hospedado para ejecutar las operaciones de sincronización de este destino',
      agentNone: 'Ninguno (hospedado en la nube)',
      testConnection: 'Probar conexión',
      testing: 'Probando conexión...',
      connectionSuccessful: 'Conexión exitosa',
      allFieldsRequired: 'Todos los campos son requeridos para probar la conexión',
      testBeforeProceeding: 'Por favor pruebe la conexión exitosamente antes de continuar',
      validationFailed: 'Validación fallida. Por favor verifique el formulario.',
      back: 'Atrás',
      next: 'Siguiente: Seleccionar tablas',
      creating: 'Creando...',
    },
    tables: {
      title: 'Seleccionar tablas',
      description: 'Elija qué tablas sincronizar',
      cardTitle: 'Tablas disponibles',
      cardDescription: 'Seleccione una o más tablas de su origen de Dataverse para sincronizar',
      tablesLabel: 'Tablas',
      selected: 'seleccionadas',
      selectAll: 'Seleccionar todo',
      deselectAll: 'Deseleccionar todo',
      searchPlaceholder: 'Buscar tablas por nombre...',
      loadingTables: 'Cargando tablas...',
      noTablesFound: 'No se encontraron tablas que coincidan con su búsqueda',
      noTablesAvailable: 'No hay tablas disponibles',
      pleaseSelectAtLeastOne: 'Por favor seleccione al menos una tabla',
      sourceNotFound: 'Origen no encontrado',
      addingTables: 'Agregando tablas...',
      finishAddTables: 'Finalizar y agregar {count} tabla',
      finishAddTablesPlural: 'Finalizar y agregar {count} tablas',
      sourceTablesAddedSuccessfully: 'Tablas de origen agregadas exitosamente',
      nextConfigureQuietTime: 'Siguiente: Configurar tiempo de inactividad',
      back: 'Atrás',
      timestampField: 'Elija un campo de marca de tiempo para sincronizaciones incrementales',
      timestampFieldDescription: 'Campo utilizado para sincronización incremental',
      timestampFieldNone: 'Ninguno (replicación completa)',
      incrementalSyncVia: 'Sincronización incremental mediante {field}',
      fullReplication: 'Replicación completa (no hay campo de marca de tiempo disponible)',
      noTimestampFieldNotice: 'No hay columnas de marca de tiempo disponibles para esta tabla. Cada sincronización realizará una replicación completa de todos los registros.',
      nameTooLongForPrefix: 'Nombre demasiado largo para el prefijo de tabla de este perfil.',
    },
    quietTime: {
      title: 'Configurar tiempo de inactividad',
      description: 'Configure ventanas de tiempo cuando las sincronizaciones se omitirán automáticamente',
      cardTitle: 'Período de tiempo de inactividad',
      cardDescription:
        'Configure ventanas de tiempo cuando las sincronizaciones se omitirán. Esto es opcional pero recomendado.',
      infoAlert:
        'Todos los horarios están en UTC. Los períodos de tiempo de inactividad ayudan a evitar sincronizaciones durante ventanas de mantenimiento o tiempos de uso pico.',
      existingSchedules:
        'Tiene {count} horario de tiempo de inactividad configurado. Puede agregar más abajo o continuar al siguiente paso.',
      existingSchedulesPlural:
        'Tiene {count} horarios de tiempo de inactividad configurados. Puede agregar más abajo o continuar al siguiente paso.',
      type: 'Tipo',
      typeDaily: 'Todos los días',
      typeWeekly: 'Días específicos',
      selectDays: 'Seleccionar días',
      startTime: 'Hora de inicio (UTC)',
      endTime: 'Hora de fin (UTC)',
      hourPlaceholder: 'HH',
      minutePlaceholder: 'MM',
      durationExceeded: 'El tiempo de inactividad no debe exceder 8 horas. Duración actual: {hours} horas',
      addQuietTimeBlock: 'Agregar bloque de tiempo de inactividad',
      creating: 'Creando...',
      quietTimeScheduleCreatedSuccessfully: 'Horario de tiempo de inactividad creado exitosamente',
      back: 'Atrás',
      nextConfigureDeleteMode: 'Siguiente: Configurar modo de eliminación',
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      configuredSchedules: 'Horarios configurados',
      recurrence: 'Recurrencia',
      noDaysSelected: 'No hay días seleccionados',
    },
    deleteMode: {
      title: 'Configurar modo de eliminación',
      description: 'Elija cómo se manejan los registros eliminados durante la sincronización',
      cardTitle: 'Modo de eliminación',
      cardDescription: 'Seleccione cómo desea manejar los registros eliminados del origen',
      softDelete: 'Eliminación suave',
      softDeleteDescription:
        'Marcar registros como eliminados (IsDeleted = true) pero mantenerlos en la base de datos. Mejor para auditorías y datos históricos.',
      hardDelete: 'Eliminación permanente',
      hardDeleteDescription:
        'Eliminar físicamente los registros de la base de datos cuando se eliminan en el origen.',
      infoMessage:
        'Esta configuración determina cómo se manejan en la base de datos de destino los registros eliminados en el sistema de origen. Elija cuidadosamente ya que esto afecta la integridad de los datos.',
      recommended: 'Recomendado',
      warningAfterInitialSync:
        'Advertencia: Cambiar el modo de eliminación después de la sincronización inicial puede causar inconsistencias en los datos. Proceda con precaución.',
      saving: 'Guardando...',
      nextRunInitialSync: 'Siguiente: Ejecutar sincronización inicial',
      successMessage: 'Modo de eliminación configurado exitosamente',
      back: 'Atrás',
    },
    initialSync: {
      title: 'Ejecutar sincronización inicial',
      description: 'Inicie la primera sincronización para comenzar a sincronizar sus datos',
      cardTitle: 'Sincronización inicial',
      cardDescription:
        'Ejecute su primera sincronización para comenzar a sincronizar datos desde su origen a su destino',
      infoAlert:
        'La sincronización inicial procesará todas las tablas seleccionadas y creará el conjunto de datos inicial en su base de datos de destino. Esto puede tomar algún tiempo dependiendo de la cantidad de datos.',
      triggeredSuccessfully: '¡Sincronización inicial iniciada exitosamente! Redirigiendo a la página del perfil...',
      triggering: 'Iniciando sincronización inicial...',
      triggeringButton: 'Iniciando...',
      triggeredButton: 'Iniciado',
      triggerInitialSync: 'Iniciar sincronización inicial',
      initialSyncTriggeredSuccessfully: 'Sincronización inicial iniciada exitosamente',
      back: 'Atrás',
    },
  },
  organizationSetupWizard: {
    title: 'Mission Data',
    createError: 'Error al crear la organización',
    unexpectedError: 'Ocurrió un error inesperado',
    regionSetupError: 'Error al actualizar la configuración de la organización',
    setupComplete: 'Configuración de la organización completada',
  },
  organizationWizard: {
    welcome: {
      title: 'Bienvenido a Mission Impact Data Mission',
      description: "Vamos a configurar su organización",
      intro: "Para comenzar, necesitará crear una organización. Una organización le ayuda a:",
      benefit1: 'Administrar los miembros de su equipo y su acceso',
      benefit2: 'Organizar sus fuentes de datos y perfiles',
      benefit3: 'Colaborar con otros en tareas de integración de datos',
      benefit4: 'Mantener su trabajo separado de otras organizaciones',
      creatorNote:
        "Como creador, automáticamente se convertirá en el Administrador con control total sobre su organización.",
      getStarted: 'Comenzar',
    },
    name: {
      title: 'Crear su organización',
      description: 'Elija un nombre para su organización',
      organizationName: 'Nombre de la organización',
      organizationNamePlaceholder: 'Ingrese el nombre de la organización',
      organizationNameCannotBeEmpty: 'El nombre de la organización no puede estar vacío',
      creating: 'Creando...',
      createOrganization: 'Crear organización',
    },
    language: {
      title: 'Elija su idioma',
      description: 'Seleccione su idioma preferido para la aplicación',
      languageLabel: 'Idioma',
      languageDescription: 'Puede cambiar esto más tarde en la configuración',
      english: 'English',
      french: 'Français',
      german: 'Deutsch',
      spanish: 'Español',
      continue: 'Continuar',
    },
    region: {
      title: 'Establecer región predeterminada',
      description: 'Elija una región de Azure predeterminada para su organización',
      defaultRegion: 'Región predeterminada',
      defaultRegionDescription: 'La región de Azure predeterminada para nuevos perfiles en esta organización',
      noDefaultRegion: 'Sin región predeterminada',
      saving: 'Guardando...',
      complete: 'Completar configuración',
    },
    success: {
      title: 'Organización creada exitosamente',
      description: 'Su organización está lista para usar',
      message: "Su organización ha sido creada y se le ha asignado como Administrador.",
      redirecting: 'Redirigiendo al panel de control...',
    },
  },
  userOnboardingWizard: {
    title: 'Bienvenido a Data Mission',
    steps: {
      welcome: 'Bienvenida',
      language: 'Idioma',
      theme: 'Tema',
      organization: 'Organización',
      eula: 'Acuerdo',
      complete: 'Completar',
    },
    welcomeStep: {
      title: 'Bienvenido a Data Mission',
      description: "Vamos a configurarlo",
      intro:
        'Data Mission le ayuda a sincronizar sus datos de Microsoft Dataverse a su propia base de datos de SQL Server, dándole control total sobre sus datos para informes y análisis.',
      feature1: 'Sincronización de datos automatizada e incremental',
      feature2: 'Control total sobre sus datos sincronizados',
      feature3: 'Configuración fácil con configuración guiada',
      getStarted: 'Comenzar',
    },
    languageStep: {
      title: 'Elija su idioma',
      description: 'Seleccione su idioma preferido para la aplicación',
      languageLabel: 'Idioma',
      continue: 'Continuar',
    },
    themeStep: {
      title: 'Elija su tema',
      description: 'Seleccione su tema de color preferido',
      light: 'Claro',
      lightDescription: 'Un tema brillante para uso diurno',
      dark: 'Oscuro',
      darkDescription: 'Un tema más oscuro que es más fácil para los ojos',
      system: 'Sistema',
      systemDescription: 'Coincidir automáticamente con la configuración de su sistema',
      back: 'Atrás',
      continue: 'Continuar',
    },
    organizationStep: {
      title: 'Sus organizaciones',
      description:
        'Las organizaciones le ayudan a administrar su equipo y datos. Se requiere una organización para usar Data Mission.',
      activeMemberships: 'Membresías activas',
      pendingInvites: 'Invitaciones pendientes',
      pendingInvitesDescription: 'Ha sido invitado a unirse a las siguientes organizaciones',
      role: 'Rol',
      expires: 'Expira',
      accept: 'Aceptar',
      accepting: 'Aceptando...',
      decline: 'Rechazar',
      declining: 'Rechazando...',
      createNew: 'Crear nueva organización',
      createNewDescription: 'Comenzar de nuevo con su propia organización',
      organizationName: 'Nombre de la organización',
      organizationNamePlaceholder: 'Ingrese el nombre de la organización',
      organizationNameRequired: 'Se requiere el nombre de la organización',
      creating: 'Creando...',
      create: 'Crear organización',
      back: 'Atrás',
      acceptError: 'Error al aceptar la invitación. Por favor intente de nuevo.',
      declineError: 'Error al rechazar la invitación. Por favor intente de nuevo.',
      createError: 'Error al crear la organización. Por favor intente de nuevo.',
    },
    agreementStep: {
      title: 'Términos de servicio',
      description: 'Por favor revise y acepte los términos para continuar',
      loading: 'Cargando...',
      loadError: 'Error al cargar el acuerdo. Por favor intente de nuevo más tarde.',
      accept: 'Aceptar',
      accepting: 'Aceptando...',
      back: 'Atrás',
      acceptError: 'Error al aceptar el acuerdo. Por favor intente de nuevo.',
      noAgreementsRequired: 'No se requiere la aceptación de acuerdos en este momento.',
      privacyPolicyTitle: 'Política de privacidad',
      termsOfUseTitle: 'Términos de uso',
      scrollToAccept: 'Desplácese hacia abajo para aceptar',
    },
    communicationPreferencesStep: {
      title: 'Elija sus preferencias de comunicación',
      description: 'Seleccione los tipos de comunicaciones que desea recibir de nosotros',
      productUpdates: {
        label: 'Actualizaciones de productos, funciones y servicios',
        description: 'Manténgase informado sobre nuevas funciones, actualizaciones de productos y mejoras de servicio.',
      },
      newsTrainingArticles: {
        label: 'Noticias, capacitación y artículos',
        description: 'Le enviaremos correos electrónicos con noticias, actualizaciones de capacitación y artículos útiles sobre Data Mission Sync.',
      },
      back: 'Atrás',
      continue: 'Continuar',
      saving: 'Guardando...',
      saveError: 'Error al guardar las preferencias de comunicación. Por favor intente de nuevo.',
    },
    completeStep: {
      title: 'Configuración completada',
      description: 'Está listo para comenzar a usar Data Mission',
      summary: 'Sus preferencias',
      language: 'Idioma',
      theme: 'Tema',
      completing: 'Completando...',
      complete: 'Comenzar',
      error: 'Error al completar la configuración. Por favor intente de nuevo.',
    },
  },
  dialogs: {
    deleteProfile: {
      title: 'Eliminar perfil',
      description: '¿Está seguro de que desea eliminar el perfil',
      confirmationLabel: 'nombre del perfil',
      buttonText: 'Eliminar perfil',
      successMessage: 'Perfil eliminado exitosamente',
      warningIntro: 'Eliminar este perfil también eliminará permanentemente:',
      warningSources: 'Todos los orígenes asociados con este perfil',
      warningTargets: 'Todos los destinos asociados con este perfil',
      warningSourceTables: 'Todas las tablas de origen asociadas con los orígenes',
      warningWebhooks: 'Todas las suscripciones de webhook asociadas con los orígenes',
    },
    deleteSource: {
      title: 'Eliminar origen',
      description: '¿Está seguro de que desea eliminar este origen?',
      confirmationKey: 'ELIMINAR ORIGEN',
      confirmationLabel: 'texto de confirmación',
      buttonText: 'Eliminar',
      successMessage: 'Origen eliminado exitosamente',
      warningIntro: 'Eliminar este origen también eliminará permanentemente:',
      warningRoutes: 'Todas las rutas que usan este origen',
      warningSourceTables: 'Todas las tablas de origen asociadas con este origen',
      warningWebhooks: 'Todas las suscripciones de webhook asociadas con este origen',
      baseUrl: 'URL base:',
    },
    deleteTarget: {
      title: 'Eliminar destino',
      description: '¿Está seguro de que desea eliminar este destino?',
      buttonText: 'Eliminar destino',
      cancel: 'Cancelar',
      deleting: 'Eliminando...',
      successMessage: 'Destino eliminado exitosamente',
      warning: 'Advertencia: Esta acción no se puede deshacer.',
      warningDescription: 'Eliminar este destino también eliminará permanentemente:',
      warningRoutes: 'Todas las rutas que usan este destino',
      server: 'Servidor:',
      database: 'Base de datos:',
    },
    deleteSchedule: {
      title: 'Eliminar horario',
      description:
        '¿Está seguro de que desea eliminar este horario de tiempo de inactividad? Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      successMessage: 'Horario eliminado exitosamente',
      errorMessage: 'Error al eliminar el horario',
    },
    confirmDelete: {
      warning: 'ADVERTENCIA:',
      defaultWarning: 'Esta acción no se puede deshacer.',
      typeToConfirm: 'Escriba lo siguiente para confirmar:',
      enterPrefix: 'Ingrese',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      deleting: 'Eliminando...',
    },
    newOrganization: {
      title: 'Crear nueva organización',
      description: 'Ingrese un nombre para su nueva organización. Puede cambiar esto más tarde en la configuración.',
      organizationName: 'Nombre de la organización',
      organizationNamePlaceholder: 'Mi organización',
      billingCountry: 'País de facturación',
      billingCountryDescription: 'Seleccione el país para propósitos de facturación. Esto no se puede cambiar después.',
      billingCountryPlaceholder: 'Seleccione un país',
      billingCountrySearch: 'Buscar países...',
      billingCountryNoResults: 'No se encontró ningún país.',
      cancel: 'Cancelar',
      create: 'Crear',
      organizationCreatedSuccessfully: '¡Organización creada exitosamente!',
    },
    setBillingCountry: {
      title: 'Establecer país de facturación',
      description: 'Por favor seleccione un país de facturación para su organización. Esto es requerido para continuar.',
      billingCountry: 'País de facturación',
      billingCountryRequired: 'Se requiere un país de facturación',
      save: 'Guardar',
      saving: 'Guardando...',
      billingCountryUpdated: '¡País de facturación actualizado exitosamente!',
    },
    inviteUser: {
      title: 'Invitar nuevo usuario',
      description: 'Enviar una invitación a un nuevo usuario para unirse a su organización',
      email: 'Correo electrónico',
      emailPlaceholder: 'juan.perez@ejemplo.com',
      role: 'Rol',
      rolePlaceholder: 'Seleccione un rol',
      roleReader: 'Lector',
      roleOperator: 'Operador',
      roleAdministrator: 'Administrador',
      roleBillingManager: 'Gestor de facturación',
      roleExpiration: 'Fecha de expiración del rol (Opcional)',
      roleExpirationPlaceholder: 'Seleccione una fecha',
      roleExpiresOn: "El rol del usuario expirará el {date}",
      invitationExpiresNote:
        'Nota: La invitación expirará automáticamente 7 días después de ser enviada',
      cancel: 'Cancelar',
      sending: 'Enviando...',
      sendInvite: 'Enviar invitación',
      userInvitedSuccessfully: '¡Usuario invitado exitosamente!',
    },
    editUserRole: {
      title: 'Editar rol de usuario',
      description: 'Cambiar el rol para {email}',
      roleLabel: 'Rol',
      rolePlaceholder: 'Seleccione un nuevo rol',
      membershipExpiration: 'Fecha de expiración de membresía (Opcional)',
      membershipExpirationIndefinite: 'Indefinido',
      membershipExpiresOn: 'La membresía expirará el {date}',
      clearExpiration: 'Limpiar',
      cancel: 'Cancelar',
      update: 'Actualizar rol',
      updating: 'Actualizando...',
      triggerLabel: 'Editar rol de usuario',
      roleUpdated: 'Rol actualizado exitosamente',
    },
    removeMember: {
      title: 'Eliminar usuario',
      description: '¿Está seguro de que desea eliminar a {email} de esta organización?',
      cancel: 'Cancelar',
      remove: 'Eliminar usuario',
      removing: 'Eliminando...',
      triggerLabel: 'Eliminar usuario de la organización',
      userRemoved: 'Usuario eliminado de la organización',
    },
    reinviteUser: {
      title: 'Re-invitar usuario',
      description: 'Enviar una nueva invitación a {email}',
      emailLabel: 'Correo electrónico',
      roleLabel: 'Rol',
      rolePlaceholder: 'Seleccione un rol',
      membershipExpiration: 'Fecha de expiración de membresía (Opcional)',
      membershipExpirationIndefinite: 'Indefinido',
      membershipExpiresOn: 'La membresía expirará el {date}',
      clearExpiration: 'Limpiar',
      invitationExpiresNote:
        'Nota: La invitación expirará automáticamente 7 días después de ser enviada',
      cancel: 'Cancelar',
      sending: 'Enviando...',
      sendInvitation: 'Enviar invitación',
      triggerLabel: 'Re-invitar usuario',
      invitationSent: 'Invitación enviada exitosamente',
    },
    acceptInvitation: {
      title: 'Invitación a organización',
      description: 'Ha sido invitado a unirse a una organización',
      organization: 'Organización:',
      role: 'Rol:',
      expiresOn: 'Esta invitación expira el {date}',
      question: '¿Le gustaría aceptar esta invitación y unirse a la organización?',
      decline: 'Rechazar',
      accept: 'Aceptar invitación',
      processing: 'Procesando...',
    },
    redeemTrial: {
      title: 'Canjear prueba',
      description: 'Canjear un código de prueba para {orgName}',
      organization: 'Organización',
      trialCode: 'Código de prueba',
      trialCodePlaceholder: 'Código de prueba de 32 caracteres',
      trialCodeRequired: 'Se requiere el código de prueba',
      trialCodeInvalid: 'El código de prueba debe tener 32 caracteres alfanuméricos',
      cancel: 'Cancelar',
      redeeming: 'Canjeando...',
      redeem: 'Canjear',
      trialRedeemedSuccessfully: 'Prueba canjeada exitosamente',
      noOrganizationSelected: 'No hay organización seleccionada',
      failedToRedeemTrial: 'Error al canjear la prueba.',
    },
    syncConfirmation: {
      titleFull: 'Sincronización completa',
      titleReset: 'Reiniciar y sincronización completa',
      descriptionFull: 'Está a punto de realizar una operación de sincronización completa.',
      descriptionReset: 'Está a punto de realizar una operación destructiva de reinicio y sincronización completa.',
      warningReset:
        'Advertencia: Esta es una acción destructiva y los datos estarán temporalmente no disponibles.',
      warningResetOperations: 'Esta operación:',
      warningResetOperation1: 'Eliminará los datos existentes en el destino',
      warningResetOperation2: 'Realizará una sincronización completa desde el origen',
      warningResetOperation3: 'Puede causar indisponibilidad temporal de datos',
      warningFull: 'Esto sincronizará todos los datos del origen.',
      warningFullDescription:
        'Una sincronización completa procesa todos los registros del origen, independientemente de si han sido sincronizados antes. Esto puede tomar más tiempo que una sincronización incremental y consumir más recursos.',
      acknowledgeReset:
        'Entiendo que esto eliminará todos los datos existentes y reiniciará el estado de sincronización. Quiero proceder con el reinicio y sincronización completa.',
      cancel: 'Cancelar',
      syncing: 'Sincronizando...',
      startFullSync: 'Iniciar sincronización completa',
      resetAndSync: 'Reiniciar y sincronizar',
    },
    deleteSourceTable: {
      buttonText: 'Eliminar tabla de origen',
      title: 'Eliminar tabla de origen',
      description: 'Eliminar una tabla de origen detiene las sincronizaciones futuras.',
      confirmationLabel: 'nombre de la tabla',
      sourceTableDeletedSuccessfully: 'Tabla de origen eliminada exitosamente',
    },
    agreementAcceptance: {
      title: 'Acuerdo legal',
      description: 'Por favor revise y acepte el acuerdo para continuar.',
      loading: 'Cargando...',
      loadError: 'Error al cargar el acuerdo. Por favor intente de nuevo más tarde.',
      accept: 'Aceptar',
      accepting: 'Aceptando...',
      decline: 'Rechazar',
      declining: 'Rechazando...',
      acceptError: 'Error al aceptar el acuerdo. Por favor intente de nuevo.',
      privacyPolicyTitle: 'Política de privacidad',
      termsOfUseTitle: 'Términos de uso',
      scrollToAccept: 'Desplácese hacia abajo para aceptar',
    },
  },
  allRuns: {
    title: 'Todas las ejecuciones',
    description: 'Ver todas las ejecuciones de sincronización en todos los perfiles de su organización',
    noOrganization: 'No hay organización seleccionada',
    runHistory: 'Historial de ejecuciones',
    filteredResults: 'Resultados filtrados',
    filtersActive: 'filtros activos',
    filter: 'filtro',
    allSyncRuns: 'Todas las ejecuciones de sincronización en todos los perfiles',
    noRunsFound: 'No se encontraron ejecuciones de sincronización.',
    refresh: 'Actualizar',
    liveUpdates: {
      label: 'Actualizaciones en vivo',
      tooltip: 'Actualizar datos automáticamente cada 5 segundos. Se desactiva automáticamente después de 5 minutos.',
      autoDisabledMessage: 'Las actualizaciones en vivo se han desactivado automáticamente después de 5 minutos.',
      reenableButton: 'Reactivar',
    },
    showSkipped: {
      label: 'Mostrar omitidas',
      tooltip: 'Las ejecuciones omitidas están ocultas de forma predeterminada. Actívelo para incluirlas en la lista.',
    },
    table: {
      runId: 'ID de ejecución',
      profile: 'Perfil',
      sourceTable: 'Tabla de origen',
      scheduled: 'Programado',
      started: 'Iniciado',
      completed: 'Completado',
      state: 'Estado',
      duration: 'Duración',
      extractionStarted: 'Extracción iniciada',
      extractionCompleted: 'Extracción completada',
      extractionDuration: 'Duración de extracción',
      loadStarted: 'Carga iniciada',
      loadCompleted: 'Carga completada',
      loadDuration: 'Duración de carga',
      rowsExtracted: 'Filas extraídas',
      rowsLoaded: 'Filas cargadas',
      rowsInserted: 'Filas insertadas',
      rowsUpdated: 'Filas actualizadas',
      rowsDeleted: 'Filas eliminadas',
      rows: 'filas',
      progress: 'Progreso',
      syncMode: 'Modo de sincronización',
      triggerSource: 'Disparador',
      region: 'Región',
      schemaChanges: 'Cambios de esquema',
      actions: 'Acciones',
    },
    schemaChanges: {
      title: 'Cambios de esquema',
      columnsCreated: 'Columnas creadas',
      columnsWidened: 'Ampliación de columnas',
      failedMigrations: 'Migraciones fallidas',
      columnName: 'Columna',
      sqlType: 'Tipo SQL',
      entity: 'Entidad',
      fromType: 'Desde',
      toType: 'Hasta',
      noChanges: 'No se registraron cambios de esquema para esta ejecución.',
      viewChanges: 'Ver {0} cambios',
    },
    actions: {
      cancel: 'Cancelar',
      cancelSuccess: 'Ejecución cancelada exitosamente',
      cancelError: 'Error al cancelar la ejecución',
      copiedToClipboard: 'Copiado al portapapeles',
      failedToCopy: 'Error al copiar',
    },
    columnToggle: {
      columnsButton: 'Columnas',
      toggleColumnsLabel: 'Alternar columnas',
      showAllColumns: 'Mostrar todas las columnas',
      extractionSection: 'Extracción',
      loadSection: 'Carga',
      rows: 'Filas',
    },
    pagination: {
      page: 'Página',
      showing: 'Mostrando',
      runs: 'ejecuciones',
      previous: 'Anterior',
      next: 'Siguiente',
    },
    errors: {
      failedToLoad: 'Error al cargar las ejecuciones',
    },
    filters: {
      filterButton: 'Filtrar',
      profile: 'Perfil',
      runState: 'Estado de ejecución',
      sourceTable: 'Tabla de origen',
      noProfilesAvailable: 'No hay perfiles disponibles',
      noSourceTablesAvailable: 'No hay tablas de origen disponibles',
      customSourceTable: 'Ingrese nombre de tabla...',
      clearAll: 'Limpiar todo',
      unknownProfile: 'Perfil desconocido',
    },
  },
  help: {
    title: 'Ayuda',
    description: 'Obtenga soporte y encuentre recursos útiles',
    additionalResources: {
      title: 'Recursos adicionales',
      description: 'Encuentre documentación, guías y tutoriales en nuestro sitio de soporte',
      content: 'Encuentre recursos adicionales en el sitio de soporte',
      comingSoon: '(próximamente)',
    },
    chatWithSupport: {
      title: 'Chat con soporte',
      description: 'Obtenga ayuda directamente de nuestro equipo de soporte',
      comingSoon: 'Próximamente',
    },
  },
  billing: {
    title: 'Facturación',
    description: 'Administre su suscripción y derechos',
    redeemTrialCode: 'Canjear código de prueba',
    subscribe: 'Suscribirse',
    customerPortal: 'Portal del cliente',
    manageSubscription: 'Administrar facturación',
    customerPortalTooltip: 'Actualizar suscripción, ver facturas y cambiar métodos de pago.',
    entitlementsTable: {
      title: 'Derechos',
      type: 'Tipo',
      ruleType: 'Tipo de regla',
      profiles: 'Perfiles',
      status: 'Estado',
      expirationDate: 'Fecha de fin',
      noEntitlements: 'No se encontraron derechos.',
      trial: 'Prueba',
      paid: 'Suscripción',
      default: 'Predeterminado',
      active: 'Activo',
      expired: 'Expirado',
      pastDue: 'Vencido',
      renewal: 'Renovación',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      never: 'Nunca',
      renewsOn: 'Se renueva el {date}',
      expiresOn: 'Expira el {date}',
      neverExpires: 'Nunca expira',
      ruleTypes: {
        minimum: 'Mínimo',
        minimumTooltip: 'Este derecho otorga al menos {value} perfiles activos.',
        cumulative: 'Acumulativo',
        cumulativeTooltip: 'Este derecho otorga {value} perfiles activos adicionales.',
      },
    },
    pastDueAlert: {
      title: 'Pago requerido',
      alertTitle: 'Pago vencido',
      description: 'El pago de su suscripción está vencido. Por favor actualice su método de pago para evitar la interrupción del servicio.',
    },
    trialExpirationAlert: {
      alertTitle: 'Prueba expirando pronto',
      description: 'Su prueba expira en {days} días. Suscríbase ahora para continuar usando todas las funciones.',
    },
    noEntitlementsAlert: {
      alertTitle: 'Suscripción requerida',
      description: 'Necesita una suscripción activa para sincronizar perfiles. Suscríbase ahora para continuar.',
    },
    planPicker: {
      title: 'Elija un plan',
      description:
        'Seleccione cómo desea suscribirse. Será redirigido a nuestro proveedor de pagos para completar la compra.',
      quantity: 'Cantidad',
      total: 'Total',
      perMonth: '/mes',
      perYear: '/año',
      savePercent: 'Ahorre {percent}%',
      failedToLoad: 'No se pudieron cargar los planes disponibles',
      noPlans: 'Actualmente no hay planes disponibles para su organización.',
      planUnavailable:
        'El plan seleccionado ya no está disponible para su organización. Los planes disponibles se han actualizado.',
      checkoutError: 'No se pudo iniciar el proceso de pago. Inténtelo de nuevo.',
    },
    invoiceHistory: {
      title: 'Facturas',
      date: 'Fecha',
      amount: 'Monto',
      statusLabel: 'Estado',
      actions: 'Acciones',
      noInvoices: 'No se encontraron facturas.',
      view: 'Ver',
      showing: 'Mostrando {count} de {total} facturas',
      previous: 'Anterior',
      next: 'Siguiente',
      status: {
        draft: 'Borrador',
        open: 'Abierta',
        paid: 'Pagada',
        uncollectible: 'Incobrable',
        void: 'Anulada',
        unknown: 'Desconocido',
      },
    },
    orgBilling: {
      title: 'Información de facturación',
      billingAddress: 'Dirección de facturación',
      paymentMethod: 'Método de pago',
      noAddress: 'No hay dirección de facturación registrada',
      noPaymentMethod: 'No hay método de pago registrado',
      expires: 'Vence',
      failedToLoad: 'Error al cargar la información de facturación',
      paymentMethodTypes: {
        card: 'Tarjeta',
        acss_debit: 'Débito preautorizado (ACSS)',
        affirm: 'Affirm',
        afterpay_clearpay: 'Afterpay / Clearpay',
        alipay: 'Alipay',
        alma: 'Alma',
        amazon_pay: 'Amazon Pay',
        au_becs_debit: 'Débito BECS (AU)',
        bacs_debit: 'Débito Bacs',
        bancontact: 'Bancontact',
        billie: 'Billie',
        blik: 'BLIK',
        boleto: 'Boleto',
        card_present: 'Tarjeta (en persona)',
        cashapp: 'Cash App Pay',
        crypto: 'Cripto',
        customer_balance: 'Saldo de cuenta',
        eps: 'EPS',
        fpx: 'FPX',
        giropay: 'giropay',
        grabpay: 'GrabPay',
        ideal: 'iDEAL',
        interac_present: 'Interac',
        kakao_pay: 'Kakao Pay',
        klarna: 'Klarna',
        konbini: 'Konbini',
        kr_card: 'Tarjeta coreana',
        link: 'Link',
        mb_way: 'MB WAY',
        mobilepay: 'MobilePay',
        multibanco: 'Multibanco',
        naver_pay: 'Naver Pay',
        nz_bank_account: 'Cuenta bancaria NZ',
        oxxo: 'OXXO',
        p24: 'Przelewy24',
        pay_by_bank: 'Pagar por banco',
        payco: 'PAYCO',
        paynow: 'PayNow',
        paypal: 'PayPal',
        paypay: 'PayPay',
        payto: 'PayTo',
        pix: 'Pix',
        promptpay: 'PromptPay',
        revolut_pay: 'Revolut Pay',
        samsung_pay: 'Samsung Pay',
        satispay: 'Satispay',
        sepa_debit: 'Débito SEPA',
        sofort: 'Sofort',
        swish: 'Swish',
        twint: 'TWINT',
        us_bank_account: 'Cuenta bancaria US',
        wechat_pay: 'WeChat Pay',
        zip: 'Zip',
        unknown: 'Método de pago',
      },
    },
    manageAddOns: {
      title: 'Administrar complementos',
      description: 'Modificar los complementos de su suscripción',
      button: 'Administrar complementos',
      currentAddOns: 'Complementos actuales',
      availableAddOns: 'Complementos disponibles',
      noCurrentAddOns: 'No tiene complementos activos',
      noAvailableAddOns: 'No hay complementos adicionales disponibles',
      add: 'Agregar',
      remove: 'Eliminar',
      perMonth: '/mes',
      perYear: '/año',
      previewChanges: 'Vista previa de cambios',
      confirmChanges: 'Confirmar cambios',
      back: 'Atrás',
      noChanges: 'No hay cambios para previsualizar',
      preview: {
        title: 'Revisar cambios',
        description: 'Revise el impacto de los cambios en su suscripción',
        changesSummary: 'Resumen de cambios',
        dueToday: 'A pagar hoy',
        dueTodayDescription: 'Cargos prorrateados para el período de facturación actual',
        nextRenewal: 'Próxima renovación',
        nextRenewalDescription: 'Sus nuevos cargos recurrentes',
        effectiveDate: 'Fecha de vigencia',
        immediateCharge: 'Cargo inmediato',
        newRecurringTotal: 'Nuevo total recurrente',
        wasQuantity: '(era {quantity})',
        newItem: '(nuevo)',
        removed: '(eliminado)',
      },
      success: 'Complementos actualizados exitosamente',
      errorPreview: 'Error al previsualizar cambios',
      errorUpdate: 'Error al actualizar complementos',
      pendingChanges: 'La reducción pendiente entrará en vigor el {date}',
      cancellationScheduled: 'Su suscripción está programada para cancelación. Los complementos no pueden ser modificados.',
    },
  },
  agents: {
    title: 'Agentes',
    description: 'Administrar agentes auto-hospedados para su organización',
    addAgent: 'Agregar agente',
    loadingAgents: 'Cargando agentes...',
    noAgentsFound: 'No se encontraron agentes. Agregue un agente para comenzar.',
    table: {
      name: 'Nombre',
      status: 'Estado',
      version: 'Versión',
      lastHeartbeat: 'Último latido',
      registeredAt: 'Registrado el',
      created: 'Creado',
      actions: 'Acciones',
      lastError: 'Último error',
      viewDetails: 'Ver detalles',
    },
    detailPage: {
      title: 'Detalles del agente',
      backButton: 'Volver a agentes',
      infoCard: {
        title: 'Información del agente',
        status: 'Estado',
        version: 'Versión',
        lastHeartbeat: 'Último latido',
        registeredAt: 'Registrado el',
        lastError: 'Último error',
        noError: 'Ninguno',
      },
      logs: {
        title: 'Registros del agente',
        level: 'Nivel',
        source: 'Fuente',
        message: 'Mensaje',
        timestamp: 'Recibido a las',
        agentTime: 'Agente:',
        noLogs: 'No se han registrado registros.',
        loadMore: 'Cargar más',
        loading: 'Cargando registros...',
        error: 'Error al cargar los registros',
        showing: 'Mostrando {count} entradas',
      },
    },
    status: {
      Active: 'Activo',
      Inactive: 'Inactivo',
      Unregistered: 'No registrado',
    },
    createDialog: {
      title: 'Agregar agente',
      description: 'Crear un nuevo agente auto-hospedado para su organización',
      nameLabel: 'Nombre del agente',
      namePlaceholder: 'Mi agente',
      cancel: 'Cancelar',
      create: 'Crear agente',
      creating: 'Creando...',
      successTitle: 'Agente creado',
      successDescription: 'Su agente ha sido creado. Copie el token de registro a continuación. Este token solo se mostrará una vez.',
      registrationToken: 'Token de registro',
      tokenExpires: 'El token expira el',
      copyToken: 'Copiar token',
      tokenCopied: 'Token copiado al portapapeles',
      tokenWarning: 'Este token solo se mostrará una vez. Asegúrese de copiarlo ahora.',
      close: 'Cerrar',
    },
    editDialog: {
      title: 'Editar agente',
      description: 'Actualizar nombre del agente y tareas en paralelo',
      nameLabel: 'Nombre del agente',
      namePlaceholder: 'Mi agente',
      cancel: 'Cancelar',
      save: 'Guardar cambios',
      saving: 'Guardando...',
      success: 'Agente actualizado con éxito',
      triggerLabel: 'Editar agente',
      workerCountLabel: 'Tareas en paralelo',
      workerCountDescription: 'Cuántas tareas ejecuta el agente al mismo tiempo (1–10). Se aplica en el siguiente latido del agente. Predeterminado 4.',
      workerCountRange: 'Las tareas en paralelo deben ser un número entero entre 1 y 10',
    },
    deleteDialog: {
      title: 'Eliminar agente',
      description: '¿Está seguro de que desea eliminar el agente "{name}"? Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      delete: 'Eliminar agente',
      deleting: 'Eliminando...',
      success: 'Agente eliminado con éxito',
      triggerLabel: 'Eliminar agente',
    },
    regenerateTokenDialog: {
      title: 'Regenerar token de registro',
      description: 'Generar un nuevo token de registro para el agente "{name}". El token anterior será invalidado.',
      cancel: 'Cancelar',
      regenerate: 'Regenerar token',
      regenerating: 'Regenerando...',
      registrationToken: 'Token de registro',
      tokenExpires: 'El token expira el',
      copyToken: 'Copiar token',
      tokenCopied: 'Token copiado al portapapeles',
      tokenWarning: 'Este token solo se mostrará una vez. Asegúrese de copiarlo ahora.',
      close: 'Cerrar',
      triggerLabel: 'Regenerar token de registro',
    },
    toggleStatus: {
      activate: 'Activar',
      deactivate: 'Desactivar',
      activated: 'Agente activado con éxito',
      deactivated: 'Agente desactivado con éxito',
    },
    relativeTime: {
      justNow: 'Ahora mismo',
      minutesAgo: 'hace {count}m',
      hoursAgo: 'hace {count}h',
      daysAgo: 'hace {count}d',
      never: 'Nunca',
    },
    downloadLatest: 'Descargar último agente',
    updateAvailable: 'Actualización de agente disponible',
    updateAvailableDescription: 'Los siguientes agentes están ejecutando una versión obsoleta y deben actualizarse:',
    versionOutdated: 'Actualización disponible',
    profileAgentOutdated: 'El agente asignado a este perfil está ejecutando una versión obsoleta. Actualice a la última versión.',
    assignedAgent: 'Agente asignado',
    agentDisabled: 'Agente deshabilitado',
    agentDisabledDescription: 'Este agente está deshabilitado. Las tareas programadas se pondrán en cola y se procesarán cuando el agente se reactive.',
    health: {
      label: 'Estado de salud',
      Online: 'En línea',
      Suspect: 'Comprobando',
      Offline: 'Sin conexión',
      offlineSince: 'Sin conexión desde {time}',
    },
    healthCheck: {
      confirm: 'Comprobar estado',
      started: 'Comprobación de estado iniciada',
      checking: 'Comprobando…',
      potentialIssue: 'Posible problema',
      likelyIssue: 'Problema probable',
      healthy: 'Correcto',
      busy: 'Ocupado – la comprobación espera tras una tarea en curso',
      unresponsive: 'Sin respuesta – marcado sin conexión',
      inconclusive: 'No se pudo completar la comprobación',
      lastResult: 'Última comprobación de estado',
    },
    agentOffline: {
      title: 'Sincronizaciones en pausa – agente sin conexión',
      profileDescription: 'El agente "{agent}" que carga el destino de este perfil está sin conexión desde {time}. No se sincroniza nada hasta que vuelva a estar en línea; las sincronizaciones se reanudan automáticamente.',
      dashboardDescription: '{count} agente(s) sin conexión. Los perfiles que los usan están en pausa hasta que vuelvan a estar en línea.',
      viewAgents: 'Ver agentes',
    },
    errors: {
      failedToLoadAgents: 'Error al cargar los agentes',
    },
  },
  organizationMembers: {
    title: 'Miembros de la organización',
    description: 'Administre los miembros y sus roles en su organización',
    inviteNewUser: 'Invitar nuevo usuario',
    loadingMembers: 'Cargando miembros...',
    noMembersFound: 'No se encontraron miembros. Invite usuarios para comenzar.',
    organizationNotFound: 'Organización no encontrada',
    table: {
      email: 'Correo electrónico',
      role: 'Rol',
      status: 'Estado',
      joined: 'Se unió',
      expires: 'Expira',
      actions: 'Acciones',
    },
    roles: {
      Administrator: 'Administrador',
      Operator: 'Operador',
      Reader: 'Lector',
      Billing: 'Gestor de facturación',
    },
    status: {
      Accepted: 'Aceptado',
      Invited: 'Invitado',
      Declined: 'Rechazado',
      Expired: 'Expirado',
    },
    indefinite: 'Indefinido',
  },
  userContext: {
    noAccount: 'No hay cuenta disponible',
    authRequired: 'Se requiere autenticación interactiva',
    initFailed: 'Error en la inicialización del usuario',
    loading: 'Cargando...',
    mustUseProvider: 'useUser debe usarse dentro de un UserProvider',
  },
  authenticationError: {
    title: 'Autenticación requerida',
    description:
      'Su sesión ha expirado o la autenticación falló. Por favor inicie sesión de nuevo para continuar.',
    signInButton: 'Iniciar sesión de nuevo',
  },
  errors: {
    common: {
      title: 'Error al cargar datos',
      retry: 'Reintentar',
      failedToLoad: 'Error al cargar datos',
      networkError: 'Error de red - por favor verifique su conexión',
      serverError: 'Error del servidor - por favor intente de nuevo más tarde',
      unauthorized: 'Autenticación requerida - por favor inicie sesión de nuevo',
      forbidden: 'Acceso denegado - permisos insuficientes',
      notFound: 'Recurso no encontrado',
      unknown: 'Ocurrió un error inesperado',
    },
    profiles: {
      failedToLoadProfiles: 'Error al cargar los perfiles',
      failedToLoadProfileDetails: 'Error al cargar los detalles del perfil',
      failedToLoadSchedules: 'Error al cargar los horarios',
      failedToLoadSourceTables: 'Error al cargar las tablas de origen',
      failedToLoadRuns: 'Error al cargar las ejecuciones de sincronización',
    },
    entitlements: {
      failedToLoadEntitlements: 'Error al cargar la información de suscripción',
    },
    members: {
      failedToLoadRoles: 'Error al cargar los roles de la organización',
      failedToLoadMembers: 'Error al cargar los miembros de la organización',
    },
    codes: {
      Success: 'La operación de sincronización se completó exitosamente.',
      BadRequest: 'La solicitud no era válida o estaba mal formada. Verifique sus parámetros de configuración e intente de nuevo.',
      Unauthorized: 'Se requiere autenticación para realizar esta operación. Inicie sesión de nuevo o verifique sus credenciales.',
      Forbidden: 'No tiene permiso para realizar esta operación. Contacte a su administrador para solicitar acceso.',
      NotFound: 'No se pudo encontrar el recurso solicitado. Verifique que el perfil, origen o destino aún existe.',
      Conflict: 'Esta operación entra en conflicto con un recurso existente. Es posible que otra sincronización esté en progreso o el recurso ya existe.',
      InternalServerError: 'Ocurrió un error inesperado del servidor. Intente de nuevo más tarde. Si el problema persiste, contacte a soporte.',
      DatabaseError: 'Una operación de base de datos falló. Verifique la configuración de su base de datos e intente de nuevo.',
      ServiceUnavailable: 'El servicio no está disponible temporalmente. Espere algunos minutos e intente de nuevo.',
      DataExtractionFailed: 'No se pudieron extraer los datos del origen. Verifique la configuración de conexión de origen y que el service principal tenga acceso de lectura a la entidad de Dataverse.',
      SchemaExtractionFailed: 'No se pudo extraer la información del esquema del origen. Verifique que el service principal tenga permiso para leer metadatos de entidades en Dataverse.',
      CheckpointRetrievalFailed: 'No se pudo recuperar la información del punto de control de sincronización. El estado de sincronización puede estar corrupto. Intente realizar un Reset & Full Sync para restaurar el estado de sincronización.',
      TargetLoadFailed: 'No se pudieron cargar los datos en la base de datos de destino. Verifique la configuración de conexión de destino y que el service principal tenga permisos de escritura en el esquema de destino.',
      DataTransformationFailed: 'No se pudieron transformar los datos durante la sincronización. Los datos de origen pueden contener valores incompatibles con el esquema de destino. Verifique el mensaje de error externo para más detalles.',
      SourceConnectionFailed: 'No se pudo conectar a la fuente de Dataverse. Verifique que la URL base, Client ID y Client Secret sean correctos y que la aplicación esté registrada en el Tenant ID correcto.',
      TargetConnectionFailed: 'No se pudo conectar a la base de datos de Azure SQL de destino. Verifique el nombre del servidor, nombre de la base de datos y credenciales. Asegúrese de que el firewall permite conexiones desde servicios de Azure.',
      RateLimitExceeded: 'Se superó el límite de tasa de API de Dataverse. La sincronización se reintentará automáticamente. Si esto persiste, considere reducir la frecuencia de sincronización o contactar al soporte de Microsoft.',
      TimeoutError: 'La operación agotó el tiempo permitido antes de completarse. Esto puede indicar problemas de red o una respuesta lenta del sistema de origen o destino.',
      NetworkError: 'Ocurrió un error de red. Verifique su conexión a Internet y asegúrese de que los endpoints de origen y destino sean accesibles.',
      OrchestrationTimeout: 'La operación de sincronización superó el tiempo máximo de ejecución permitido. Para grandes volúmenes de datos, considere sincronizar menos tablas o realizar una sincronización inicial durante horas de menor actividad.',
      OrchestrationCancelled: 'La sincronización fue cancelada, ya sea manualmente o porque el perfil o la entidad asociada fue eliminada.',
      OrchestrationOrphaned: 'La operación de sincronización se interrumpió inesperadamente antes de poder completarse. Por favor, reintente la sincronización.',
      InvalidConfiguration: 'La configuración del perfil no es válida. Revise la configuración del origen, destino y tablas para asegurarse de que esté completa y correcta.',
      TargetInitialSyncConflict: 'La tabla de destino ya contiene datos de una sincronización anterior. Elimine los datos existentes de la tabla de destino o use Reset & Full Sync para comenzar desde cero.',
      DataverseCallFailed: 'Una llamada a la API de Dataverse falló inesperadamente. Verifique el mensaje de error externo para más detalles. Si el problema persiste, verifique que su entorno de Dataverse esté funcionando correctamente.',
      DataverseAuthenticationFailed: 'La autenticación a Dataverse falló. Verifique que Client ID y Client Secret sean correctos, que el secreto no haya expirado y que la aplicación esté registrada en el Tenant ID de Dataverse.',
      DataverseChangeTrackingNotEnabled: 'El seguimiento de cambios no está habilitado para esta entidad de Dataverse. Habilite el seguimiento de cambios en el centro de administración de Dataverse para permitir sincronizaciones incrementales.',
      DataverseEntityNotFound: 'La entidad de Dataverse no se encontró. Verifique que el nombre lógico de la entidad sea correcto y que la entidad exista en su entorno de Dataverse.',
      DataversePermissionDenied: 'El service principal no tiene permiso para acceder a esta entidad de Dataverse. Otorgue roles de seguridad apropiados a la aplicación en el centro de administración de Dataverse.',
      DataverseInvalidEntityConfiguration: 'La configuración de la entidad de Dataverse no es válida. La entidad puede carecer de una clave primaria o tener una estructura no soportada.',
      DataverseSecretRetrievalFailed: 'No se pudieron recuperar las credenciales del almacén seguro. Reingrese su Client Secret en la configuración de origen.',
      LockAcquisitionFailed: 'No se pudo adquirir un bloqueo en la base de datos de destino. Otra sincronización puede estar en progreso. Espere a que se complete la sincronización actual antes de reintentar.',
      AzureSqlAuthenticationFailed: 'La autenticación a Azure SQL falló. Verifique que Tenant ID, Client ID y Client Secret sean correctos. Asegúrese de que el service principal se agregó como usuario de base de datos con permisos apropiados.',
      AzureSqlConnectionTimeout: 'La conexión a Azure SQL agotó el tiempo de espera. El servidor de base de datos puede ser inaccesible, estar en pausa o experimentar alta carga. Verifique el estado del servidor en el portal de Azure.',
      AzureSqlPermissionDenied: 'El service principal no tiene permisos suficientes en la base de datos de Azure SQL. Otorgue los roles db_datareader y db_datawriter del service principal en la base de datos de destino.',
      AzureSqlSchemaMigrationFailed: 'No se pudo crear o actualizar el esquema de la base de datos. El service principal puede carecer de permiso para crear tablas, o el cambio de esquema entra en conflicto con objetos existentes.',
      AzureSqlDataImportFailed: 'No se pudieron importar los datos en Azure SQL. Verifique que los tipos de datos sean compatibles y que el service principal tenga permisos INSERT en las tablas de destino.',
      AzureSqlMergeFailed: 'La operación de fusión de datos falló. Esto puede deberse a incompatibilidades de tipos de datos, violaciones de restricciones o errores de sintaxis SQL. Verifique el mensaje de error externo para más detalles.',
      AzureSqlConstraintViolation: 'Los datos violan una restricción de base de datos (clave externa, única o restricción de verificación). Los datos de origen pueden contener referencias inválidas o claves duplicadas.',
      AzureSqlDeadlock: 'Se detectó un bloqueo mutuo durante la operación de sincronización. La operación se reintentará automáticamente. Si esto persiste, considere programar las sincronizaciones durante horas de menor actividad.',
      AzureSqlDatabaseNotFound: 'La base de datos especificada no se encontró en el servidor de Azure SQL. Verifique que el nombre de la base de datos sea correcto y que la base de datos no haya sido eliminada o renombrada.',
      AzureSqlServerNotFound: 'No se pudo alcanzar el servidor de Azure SQL. Verifique que el nombre del servidor sea correcto, que el servidor exista y que la conectividad de red permita la conexión.',
      AzureSqlTransactionTimeout: 'Una transacción de base de datos agotó el tiempo de espera. La operación tardó demasiado en completarse, posiblemente debido a contención de bloqueos o limitaciones de recursos. Considere escalar a un nivel de servicio superior.',
      AzureSqlInsufficientResources: 'La base de datos de Azure SQL tiene recursos insuficientes (CPU, memoria o DTUs) para completar la operación. Considere escalar a un nivel de servicio superior.',
      AzureSqlSchemaMetadataNotFound: 'No se encontraron los metadatos de esquema requeridos. Esto puede indicar un problema de estado de sincronización. Intente realizar un Reset & Full Sync para regenerar el esquema.',
      AzureSqlPrimaryKeyStructureChanged: 'La estructura de clave primaria de la entidad de origen ha cambiado y no se puede aplicar a la tabla de destino existente. Elimine la tabla de destino o use Reset & Full Sync.',
      AzureSqlUnsafeSchemaChange: 'El cambio de esquema de origen no se puede aplicar de forma segura. Solo se soportan cambios de ampliación de tipos de columna y hacer columnas nulables. Otros cambios requieren un Reset & Full Sync.',
      AzureSqlMergeTimeout: 'La operación de fusión de datos agotó el tiempo de espera. Esto ocurre típicamente al sincronizar grandes volúmenes de datos a una base de datos de nivel bajo. Considere escalar a un nivel de servicio superior o reducir el volumen de datos por sincronización.',
      AzureSqlFirewallBlocked: 'Conexión bloqueada por firewall de Azure SQL. Agregue la IP estática de Data Mission ({ip}) a la lista de permitidos del firewall de su servidor.',
      AzureSqlSchemaNotFound: 'El esquema especificado no existe en la base de datos de destino. Cree el esquema en Azure SQL o cambie el nombre del esquema en la configuración de destino.',
      AgentTaskTimedOut: 'El agente auto-hospedado no completó la tarea dentro del tiempo límite configurado. Verifique que el agente esté en ejecución y tenga acceso de red al origen y al destino.',
      AgentTaskFailed: 'El agente auto-hospedado reportó un fallo en la tarea. Asegúrese de que el software del agente esté actualizado y revise los registros del agente para más detalles.',
      UnsupportedTaskType: 'El agente recibió un tipo de tarea que no soporta. Asegúrese de que el software del agente esté actualizado.',
      AgentTaskNotPickedUp: 'El agente auto-hospedado no inició la tarea en 10 minutos aunque no estaba ocupado con otro trabajo. Verifique que el servicio del agente esté en ejecución y conectado.',
      SupportServiceUnavailable: 'El soporte no está disponible temporalmente. Vuelva a intentarlo en unos minutos.',
      SupportServiceMisconfigured: 'El soporte no está disponible temporalmente. Vuelva a intentarlo más tarde o contáctenos si el problema persiste.',
      '40615': 'Su dirección IP no tiene permitido conectarse al servidor. Agregue esta IP a las reglas de firewall de Azure SQL.',
      '-2': 'Tiempo de espera de conexión agotado. El servidor puede ser inalcanzable o las reglas de firewall pueden estar bloqueando el acceso.',
      '-1': 'Tiempo de espera de conexión agotado. El servidor puede ser inalcanzable o las reglas de firewall pueden estar bloqueando el acceso.',
      '18456': 'Inicio de sesión fallido. Verifique que sus credenciales sean correctas y tengan acceso a la base de datos.',
      '4060': 'No se puede acceder a la base de datos. Verifique que la base de datos existe y el service principal tiene acceso.',
      '297': 'El service principal no tiene permiso para acceder a la base de datos.',
      '916': 'El service principal no tiene permiso para acceder a la base de datos.',
      '53': 'Error de red al conectar con el servidor. El servidor puede ser inalcanzable o las reglas de firewall pueden estar bloqueando el acceso.',
      '10054': 'Error de red al conectar con el servidor. El servidor puede ser inalcanzable o las reglas de firewall pueden estar bloqueando el acceso.',
      '10060': 'Error de red al conectar con el servidor. El servidor puede ser inalcanzable o las reglas de firewall pueden estar bloqueando el acceso.',
      '10061': 'Error de red al conectar con el servidor. El servidor puede ser inalcanzable o las reglas de firewall pueden estar bloqueando el acceso.',
      '20': 'La instancia no está configurada para aceptar conexiones. Verifique el nombre del servidor y la conectividad.',
      '1202': 'Error al conectar con el destino. No se pudo alcanzar el servidor Azure SQL. Verifique su configuración de conexión.',
      '1501': 'Error de autenticación. Verifique que su Tenant ID, Client ID y Client Secret sean correctos y que el service principal tenga acceso a la base de datos.',
      '1502': 'Tiempo de conexión agotado. El servidor Azure SQL puede ser inalcanzable o estar experimentando alta carga.',
      '1503': 'El service principal no tiene suficientes permisos SQL para operaciones de sincronización. Otorgue los permisos necesarios.',
      '1509': 'Base de datos no encontrada. Verifique que el nombre de la base de datos existe y que el service principal tiene acceso.',
      '1510': 'Servidor no encontrado o error de red. Verifique el nombre del servidor Azure SQL y la conectividad de red.',
      '1517': 'Conexión bloqueada por firewall. Configure el firewall de su servidor Azure SQL para permitir servicios de Azure o agregue los rangos de IP para Azure Canada Central y su región de perfil.',
      '1518': 'Esquema no encontrado. El esquema especificado no existe en la base de datos. Verifique el nombre del esquema o créelo.',
      DataverseHostnameNotFound: 'No se pudo resolver el nombre de host de Dataverse. Verifique que la URL base sea correcta y que la organización exista.',
      DataverseInvalidUrl: 'Formato de URL de organización de Dataverse inválido. Verifique que la URL base sea una URL HTTPS válida.',
      DataverseInvalidClientId: 'ID de cliente inválido. El identificador de la aplicación no es reconocido. Verifique el registro de su aplicación de Azure AD.',
      DataverseInvalidClientSecret: 'Client Secret inválido. El Client Secret es incorrecto o ha expirado. Verifique o regenere su Client Secret.',
      DataverseInvalidAppRegistration: 'Registro de aplicación inválido. La aplicación no tiene acceso a esta instancia de Dataverse o no está registrada en el inquilino.',
      DataverseInvalidTenant: 'No se puede determinar el inquilino de autenticación desde la URL de Dataverse. Verifique que el formato de la URL base sea correcto.',
      DataverseConnectionFailed: 'Error al conectar con la instancia de Dataverse. Verifique que la URL base sea correcta y que la instancia sea accesible.',
      DataversePermissionDeniedMetadata: 'Falta permiso para leer metadatos de entidad. El service principal no puede recuperar información de esquema de Dataverse.',
      DataversePermissionDeniedData: 'Falta permiso para leer datos de entidad. El service principal no puede leer registros de entidades de Dataverse.',
      DataverseVersionStampExpired: 'La tabla no se ha sincronizado en demasiado tiempo y el estado de sincronización incremental ha expirado. Se requiere un Reset & Full Sync para reanudar la sincronización.',
      DataverseInvalidRequest: 'Se produjo un error al leer datos de Dataverse. Verifique el mensaje de error externo para más detalles. Si el problema persiste, verifique la configuración de su entidad y los permisos.',
      BcCallFailed: 'Una llamada a la API de Business Central falló inesperadamente. Consulte el mensaje de error externo para más detalles. Si el problema persiste, verifique que su entorno de Business Central esté funcionando correctamente.',
      BcAuthenticationFailed: 'La autenticación a Business Central falló. Verifique que el Client ID y el Client Secret sean correctos, que el secreto no haya expirado y que la aplicación esté registrada en el inquilino correcto.',
      BcInvalidClientId: 'ID de cliente inválido. El identificador de la aplicación no es reconocido en Azure AD. Verifique el registro de su aplicación.',
      BcInvalidClientSecret: 'Client Secret inválido. El Client Secret es incorrecto o ha expirado. Verifique o regenere su Client Secret.',
      BcEnvironmentNotFound: 'El entorno de Business Central no fue encontrado. Verifique que el nombre del entorno sea correcto y que exista en su inquilino.',
      BcCompanyNotFound: 'La compañía de Business Central no fue encontrada. Verifique que el identificador o el nombre de la compañía sea correcto y que la compañía exista en el entorno seleccionado.',
      BcPermissionDenied: 'La entidad de servicio no tiene permiso para acceder a Business Central. Asegúrese de que la aplicación tenga los permisos de API requeridos y esté consentida en el inquilino.',
      BcEntityNotFound: 'La entidad o página API de Business Central no fue encontrada. Verifique que el nombre de la entidad sea correcto y que la página API esté publicada en Business Central.',
      BcNotFound: 'Business Central informó que no se encontró un recurso solicitado, pero no identificó si el recurso faltante era el entorno, la compañía, la entidad o el registro. Revise los detalles del error externo para la solicitud exacta.',
      BcInvalidRequest: 'Business Central rechazó la solicitud. Consulte el mensaje de error externo para más detalles sobre qué campo o parámetro es inválido.',
      BcTenantUnavailable: 'El inquilino de Business Central no está disponible actualmente. El entorno puede estar en mantenimiento o migración. Inténtelo de nuevo más tarde.',
      // Códigos de error de Salesforce
      SalesforceCallFailed:
        'Una llamada a la API de Salesforce falló inesperadamente. Revise los detalles del error. Si el problema persiste, verifique que su entorno de Salesforce esté funcionando correctamente.',
      SalesforceAuthenticationFailed:
        'La autenticación en Salesforce falló. Verifique la URL de instancia, el Client ID y el Client Secret, y que la Connected App esté activa.',
      SalesforceTokenRequestFailed:
        'No se pudo obtener un token de acceso de Salesforce. Verifique la URL de instancia y que la Connected App esté configurada para el flujo de credenciales de cliente.',
      SalesforceInvalidClientCredentials:
        'El Client ID o el Client Secret de Salesforce no son válidos. Verifique el Consumer Key y el Consumer Secret de su Connected App.',
      SalesforceInstanceUrlInvalid:
        'La URL de instancia de Salesforce no es válida o no está disponible. Verifique que sea una URL válida de Salesforce (p. ej. https://miempresa.my.salesforce.com).',
      SalesforceRateLimitExceeded:
        'Se superó el límite de solicitudes de la API de Salesforce. La sincronización se reintentará automáticamente. Si persiste, considere reducir la frecuencia de sincronización.',
      SalesforceBulkApiUnavailable:
        'La Bulk API 2.0 de Salesforce no está disponible para esta organización. Asegúrese de que la Connected App tenga los ámbitos OAuth requeridos y que el usuario tenga el permiso "API Enabled".',
      SalesforceBulkJobFailed:
        'El trabajo de consulta masiva de Salesforce falló. Revise los detalles del error y verifique que el objeto sea consultable y el usuario tenga acceso de lectura.',
      SalesforceBulkJobTimedOut:
        'El trabajo de consulta masiva de Salesforce superó el tiempo de espera. El objeto puede contener un volumen muy grande de datos. Considere reducir el número de campos sincronizados.',
      SalesforceEntityNotFound:
        'El objeto de Salesforce (SObject) no fue encontrado. Verifique que el nombre de API sea correcto y que el objeto exista en su organización.',
      SalesforceApiScopeNotGranted:
        'El token de Salesforce no tiene acceso a la API. Asegúrese de que la Connected App incluya el ámbito OAuth "api" y que el usuario tenga el permiso de sistema "API Enabled".',
      SalesforceClientCredentialsNotConfigured:
        'El flujo de credenciales de cliente no está configurado para esta Connected App. En Configuración de Salesforce, vaya a Gestor de aplicaciones → Editar políticas → Flujo de credenciales de cliente y asigne un usuario.',
      SalesforceClientIdNotRecognized:
        'El Client ID de Salesforce (Consumer Key) no es reconocido. Verifique que la URL de instancia corresponda a la organización donde está instalada la Connected App y que la app esté activa.',
      unknown: 'Ocurrió un error desconocido. Intente de nuevo o contacte a soporte.',
    },
  },
  systemNotices: {
    title: 'Avisos del sistema',
    noNotices: 'No hay avisos activos',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    acknowledge: 'Reconocer',
    acknowledgeForOrg: 'Reconocer para la organización',
    acknowledgedSuccessfully: 'Aviso reconocido exitosamente',
    noPermissionToAcknowledge: 'No tiene permiso para reconocer este aviso',
    failedToLoad: 'Error al cargar los avisos del sistema',
  },
};
